/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Delegate_$type, fromEnum, runOn, markType, Point_$type, typeGetValue, INotifyPropertyChanged_$type, PropertyChangedEventArgs, enumGetBox, EventArgs, delegateCombine, typeCast, fromEn, toNullable, Number_$type } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { ScaleTransform } from "igniteui-react-core";
import { NativeUI } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
import { KeyFrameAnimationFactory } from "igniteui-react-core";
import { AnimationKeyFrameEffect } from "igniteui-react-core";
import { AnimationKeyFrameEffectTiming } from "igniteui-react-core";
import { stringReplace, stringIsNullOrEmpty } from "igniteui-react-core";
import { TransformGroup } from "igniteui-react-core";
import { TranslateTransform } from "igniteui-react-core";
import { SuffixShiftType_$type } from "./SuffixShiftType";
import { PrefixShiftType_$type } from "./PrefixShiftType";
import { MouseButtonEventArgs } from "igniteui-react-core";
import { KeyEventArgs } from "igniteui-react-core";
import { InputShiftType_$type } from "./InputShiftType";
import { SuffixVisualModelExport } from "./SuffixVisualModelExport";
import { PrefixVisualModelExport } from "./PrefixVisualModelExport";
import { InputGroupDisplayType_$type } from "./InputGroupDisplayType";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { CornerRadius } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { ThemeResolver } from "./ThemeResolver";
import { ObservableCollection$1 } from "igniteui-react-core";
import { AnimationKeyFrameProperty } from "igniteui-react-core";
import { InputGroupVisualModelExport } from "./InputGroupVisualModelExport";
import { AppearanceHelper } from "igniteui-react-core";
import { LabelVisualModelExport } from "./LabelVisualModelExport";
import { InputVisualModelExport } from "./InputVisualModelExport";
import { BrushUtil } from "igniteui-react-core";
import { LabelShiftType_$type } from "./LabelShiftType";
import { isNaN_ } from "igniteui-react-core";
import { FontUtil } from "igniteui-react-core";
import { MaskParsingService } from "./MaskParsingService";
import { InputChangeEventArgs } from "./InputChangeEventArgs";
import { MaskOptions } from "./MaskOptions";
/**
 * @hidden
 */
var InputGroupView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputGroupView, _super);
    function InputGroupView() {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.l = null;
        _this.e = null;
        _this.i = new List$1(Delegate_$type, 0);
        _this.z = null;
        _this.f = true;
        _this.n = null;
        _this.o = null;
        _this.p = null;
        _this.t = null;
        _this.r = null;
        _this.q = null;
        _this.m = null;
        return _this;
    }
    InputGroupView.prototype.ak = function () {
    };
    InputGroupView.prototype.ac = function (a) {
    };
    InputGroupView.prototype.ae = function (a) {
    };
    InputGroupView.prototype.ad = function () {
    };
    InputGroupView.prototype.g = function () {
        return true;
    };
    Object.defineProperty(InputGroupView.prototype, "w", {
        get: function () {
            return this.n;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "as", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "h", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    InputGroupView.prototype.ah = function (a) {
        var e_1, _a;
        var _this = this;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.i)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.i.clear();
        }
        this.l = a;
        a.rootWrapper.setStyleProperty("position", "relative");
        a.rootWrapper.setStyleProperty("box-sizing", "border-box");
        a.rootWrapper.setStyleProperty("border-width", "0px");
        a.rootWrapper.setStyleProperty("border-style", "solid");
        var c = this.v;
        this.i.add(c.listen("focusin", runOn(this, this.aj)));
        this.i.add(c.listen("focusout", runOn(this, this.am)));
        var d = this.l.createElement("div");
        d.setStyleProperty("position", "absolute");
        d.setStyleProperty("width", "100%");
        d.setStyleProperty("height", "100%");
        d.setStyleProperty("border-style", "solid");
        d.setStyleProperty("box-sizing", "border-box");
        d.setStyleProperty("left", "0px");
        d.setStyleProperty("top", "0px");
        this.l.append(d);
        this.m = d;
        var e = this.l.createElement("div");
        e.addClass("ig-input-content");
        e.setStyleProperty("width", "100%");
        e.setStyleProperty("position", "relative");
        e.setStyleProperty("display", "flex");
        e.setStyleProperty("flex-direction", "row");
        e.setStyleProperty("flex-wrap", "no-wrap");
        e.setStyleProperty("flex-flow", "row nowrap");
        e.setStyleProperty("flex-grow", "1");
        e.setStyleProperty("align-items", "center");
        e.setStyleProperty("padding-top", "1.125rem");
        this.p = e;
        this.i.add(e.listen("click", runOn(this, this.aa)));
        this.l.append(e);
        this.l.getPortal(e, "ChildContent", function (f) {
            var comp_ = f.componentRef;
            _this.t = comp_;
            _this.p.setStyleProperty("flex-direction", "row");
        }, true);
        var f = this.l.createElement("div");
        f.setStyleProperty("position", "absolute");
        f.setStyleProperty("width", "100%");
        f.setStyleProperty("background-color", "rgba(0, 0, 0, 0.54)");
        f.setStyleProperty("height", "1px");
        f.setStyleProperty("pointer-events", "none");
        f.setStyleProperty("left", "0px");
        f.setStyleProperty("bottom", "1px");
        f.setStyleProperty("overflow", "visible");
        var g = this.l.createElement("span");
        g.setStyleProperty("width", "100%");
        g.setStyleProperty("height", "2px");
        g.setStyleProperty("display", "block");
        g.setStyleProperty("pointer-events", "none");
        NativeUI.z(g, ((function () {
            var $ret = new ScaleTransform();
            $ret.l = 0.5;
            $ret.m = 1;
            return $ret;
        })()));
        g.setStyleProperty("opacity", "0");
        this.r = g;
        f.append(this.r);
        this.q = f;
        this.l.append(f);
        this.d.me();
    };
    Object.defineProperty(InputGroupView.prototype, "s", {
        get: function () {
            return this.p;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "v", {
        get: function () {
            return this.l.rootWrapper;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "u", {
        get: function () {
            return this.m;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "x", {
        get: function () {
            return this.q;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "y", {
        get: function () {
            return this.r;
        },
        enumerable: true,
        configurable: true
    });
    InputGroupView.prototype.aq = function (a) {
        if (this.z != a) {
            this.z = a;
            if (this.o != null) {
                this.o.setAttribute("d", this.z);
            }
        }
    };
    InputGroupView.prototype.ap = function () {
        switch (this.d.g) {
            case 1:
                this.p.setStyleProperty("padding-top", "1.125rem");
                break;
            case 2:
                this.p.setStyleProperty("padding-top", ".94737rem");
                break;
            case 3:
                this.p.setStyleProperty("padding-top", ".81818rem");
                break;
        }
    };
    InputGroupView.prototype.aa = function (a) {
    };
    InputGroupView.prototype.al = function () {
        if (this.g()) {
        }
    };
    InputGroupView.prototype.j = function () {
        var a = this.l.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    InputGroupView.prototype.ag = function () {
        this.f = true;
    };
    InputGroupView.prototype.ai = function () {
        var e_2, _a;
        this.f = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.i)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        this.i.clear();
    };
    InputGroupView.prototype.ar = function (a) {
        if (a != null) {
            this.l.rootWrapper.setStyleProperty("font", a.fontString);
        }
    };
    InputGroupView.prototype.k = function (a) {
        return a.view.i();
    };
    InputGroupView.prototype.af = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.l;
        }
    };
    InputGroupView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.u, 0, null, a);
    };
    InputGroupView.prototype.c = function (a) {
        return new AnimationKeyFrameEffect(0, this.x, 0, null, a);
    };
    InputGroupView.prototype.b = function (a) {
        return new AnimationKeyFrameEffect(0, this.r, 0, null, a);
    };
    InputGroupView.prototype.ao = function (a) {
    };
    InputGroupView.prototype.ab = function (a) {
        this.p.append(a);
    };
    InputGroupView.prototype.an = function (a) {
        this.p.removeChild(a);
    };
    InputGroupView.prototype.aj = function (a) {
        this.d.ma();
    };
    InputGroupView.prototype.am = function (a) {
        this.d.mc();
    };
    InputGroupView.$t = markType(InputGroupView, 'InputGroupView');
    return InputGroupView;
}(Base));
export { InputGroupView };
/**
 * @hidden
 */
var SuffixView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SuffixView, _super);
    function SuffixView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.g = null;
        _this.b = null;
        _this.e = new List$1(Delegate_$type, 0);
        _this.c = true;
        _this.h = null;
        return _this;
    }
    SuffixView.prototype.o = function () {
    };
    SuffixView.prototype.d = function () {
        return true;
    };
    Object.defineProperty(SuffixView.prototype, "r", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    SuffixView.prototype.m = function (a) {
        var e_3, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_3_1) {
                e_3 = { error: e_3_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_3)
                        throw e_3.error;
                }
            }
            this.e.clear();
        }
        this.g = a;
        this.g.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.g.createElement("div");
        c.addClass("ig-suffix-content");
        this.g.append(c);
        c.setStyleProperty("cursor", "pointer");
        this.h = c;
        this.g.getPortal(c, "ChildContent", function (d) {
        }, true);
        this.a.am();
    };
    SuffixView.prototype.q = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.a.k == 2 ? (_this.f() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.z(this.g.rootWrapper, a);
        this.g.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    SuffixView.prototype.f = function () {
        var a = this.g.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    SuffixView.prototype.p = function () {
        if (this.d()) {
        }
    };
    SuffixView.prototype.i = function (a) {
        this.a.aj();
    };
    SuffixView.prototype.j = function (a) {
        this.a.ak();
    };
    SuffixView.prototype.l = function () {
        this.c = true;
        this.e.add(this.g.rootWrapper.listen("mouseenter", runOn(this, this.i)));
        this.e.add(this.g.rootWrapper.listen("mouseleave", runOn(this, this.j)));
    };
    SuffixView.prototype.n = function () {
        var e_4, _a;
        this.c = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_4_1) {
            e_4 = { error: e_4_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_4)
                    throw e_4.error;
            }
        }
        this.e.clear();
    };
    SuffixView.prototype.k = function (a) {
        this.h.append(a);
    };
    SuffixView.$t = markType(SuffixView, 'SuffixView');
    return SuffixView;
}(Base));
export { SuffixView };
/**
 * @hidden
 */
var PrefixView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PrefixView, _super);
    function PrefixView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.g = null;
        _this.b = null;
        _this.e = new List$1(Delegate_$type, 0);
        _this.c = true;
        _this.h = null;
        return _this;
    }
    PrefixView.prototype.o = function () {
    };
    PrefixView.prototype.d = function () {
        return true;
    };
    Object.defineProperty(PrefixView.prototype, "r", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    PrefixView.prototype.m = function (a) {
        var e_5, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_5_1) {
                e_5 = { error: e_5_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_5)
                        throw e_5.error;
                }
            }
            this.e.clear();
        }
        this.g = a;
        this.g.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.g.createElement("div");
        c.addClass("ig-prefix-content");
        this.g.append(c);
        c.setStyleProperty("cursor", "pointer");
        this.h = c;
        this.g.getPortal(c, "ChildContent", function (d) {
        }, true);
        this.a.am();
    };
    PrefixView.prototype.q = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.a.k == 2 ? (_this.f() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.z(this.g.rootWrapper, a);
        this.g.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    PrefixView.prototype.f = function () {
        var a = this.g.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    PrefixView.prototype.p = function () {
        if (this.d()) {
        }
    };
    PrefixView.prototype.i = function (a) {
        this.a.aj();
    };
    PrefixView.prototype.j = function (a) {
        this.a.ak();
    };
    PrefixView.prototype.l = function () {
        this.c = true;
        this.e.add(this.g.rootWrapper.listen("mouseenter", runOn(this, this.i)));
        this.e.add(this.g.rootWrapper.listen("mouseleave", runOn(this, this.j)));
    };
    PrefixView.prototype.n = function () {
        var e_6, _a;
        this.c = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_6_1) {
            e_6 = { error: e_6_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_6)
                    throw e_6.error;
            }
        }
        this.e.clear();
    };
    PrefixView.prototype.k = function (a) {
        this.h.append(a);
    };
    PrefixView.$t = markType(PrefixView, 'PrefixView');
    return PrefixView;
}(Base));
export { PrefixView };
/**
 * @hidden
 */
var LabelView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(LabelView, _super);
    function LabelView() {
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.k = null;
        _this.d = null;
        _this.h = new List$1(Delegate_$type, 0);
        _this.o = null;
        _this.e = true;
        _this.l = null;
        _this.m = null;
        return _this;
    }
    LabelView.prototype.aa = function () {
    };
    LabelView.prototype.f = function () {
        return true;
    };
    Object.defineProperty(LabelView.prototype, "n", {
        get: function () {
            return this.l;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelView.prototype, "ai", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelView.prototype, "g", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    LabelView.prototype.s = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.k;
        }
    };
    LabelView.prototype.b = function (a) {
        return new AnimationKeyFrameEffect(0, this.k.rootWrapper, 0, null, a);
    };
    LabelView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.k.rootWrapper, 0, null, a);
    };
    LabelView.prototype.v = function (a) {
        var e_7, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.h)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_7_1) {
                e_7 = { error: e_7_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_7)
                        throw e_7.error;
                }
            }
            this.h.clear();
        }
        this.k = a;
        this.k.rootWrapper.setStyleProperty("display", "inline-block");
        this.k.rootWrapper.setStyleProperty("position", "relative");
        var c = this.k.createElement("label");
        c.setStyleProperty("position", "relative");
        c.setStyleProperty("display", "inline-block");
        c.setStyleProperty("white-space", "nowrap");
        c.setStyleProperty("text-overflow", "ellipsis");
        c.setStyleProperty("line-height", "1");
        c.setStyleProperty("overflow", "hidden");
        c.setStyleProperty("height", "1.125rem");
        c.setStyleProperty("backface-visibility", "hidden");
        NativeUI.n(this.k.rootWrapper, this.c.cw);
        c.setStyleProperty("outline-style", "none");
        c.setStyleProperty("box-shadow", "none");
        c.setStyleProperty("font-family", "'Segoe UI', Verdana");
        c.setStyleProperty("font-size", "1rem");
        this.l = c;
        this.k.append(this.l);
        this.c.ce();
    };
    LabelView.prototype.j = function () {
        return 0;
    };
    LabelView.prototype.ae = function () {
        this.c.bf = "block";
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.z(this.k.rootWrapper, a);
        this.l.setStyleProperty("height", "1.125rem");
        this.k.rootWrapper.setStyleProperty("position", "absolute");
        this.k.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    LabelView.prototype.af = function () {
        switch (this.c.o) {
            case 1:
                this.k.rootWrapper.setStyleProperty("margin-top", "0px");
                break;
            case 2:
                this.k.rootWrapper.setStyleProperty("margin-top", "-.125rem");
                break;
            case 3:
                this.k.rootWrapper.setStyleProperty("margin-top", "-.25rem");
                break;
        }
    };
    LabelView.prototype.ad = function () {
        this.l.setText(this.c.text != null ? this.c.text : "");
    };
    LabelView.prototype.ag = function (a) {
        if (this.o != a) {
            this.o = a;
            if (this.m != null) {
                this.m.setAttribute("d", this.o);
            }
        }
    };
    LabelView.prototype.x = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("display", this.c.bf);
            this.l.setStyleProperty("display", this.c.bf);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onDisplayChanged) {
                ext_._onDisplayChanged();
            }
            ;
        }
    };
    LabelView.prototype.t = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("align-items", this.c.a9);
            this.l.setStyleProperty("align-items", this.c.a9);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onAlignItemsChanged) {
                ext_._onAlignItemsChanged();
            }
            ;
        }
    };
    LabelView.prototype.y = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("flex-direction", this.c.bi);
            this.l.setStyleProperty("flex-direction", this.c.bi);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onFlexDirectionChanged) {
                ext_._onFlexDirectionChanged();
            }
            ;
        }
    };
    LabelView.prototype.z = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("flex-grow", this.c.bk);
            this.l.setStyleProperty("flex-grow", this.c.bk);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onFlexGrowChanged) {
                ext_._onFlexGrowChanged();
            }
            ;
        }
    };
    LabelView.prototype.p = function (a) {
    };
    LabelView.prototype.ab = function () {
        if (this.f()) {
        }
    };
    LabelView.prototype.i = function () {
        var a = this.k.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    LabelView.prototype.q = function (a) {
        this.c.cb();
    };
    LabelView.prototype.r = function (a) {
        this.c.cc();
    };
    LabelView.prototype.u = function () {
        this.e = true;
        this.h.add(this.k.rootWrapper.listen("mouseenter", runOn(this, this.q)));
        this.h.add(this.k.rootWrapper.listen("mouseleave", runOn(this, this.r)));
    };
    LabelView.prototype.w = function () {
        var e_8, _a;
        this.e = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.h)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_8_1) {
            e_8 = { error: e_8_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_8)
                    throw e_8.error;
            }
        }
        this.h.clear();
    };
    LabelView.prototype.ah = function (a) {
        if (a != null) {
            this.l.setStyleProperty("font", a.fontString);
        }
    };
    LabelView.prototype.ac = function (a) {
        NativeUI.n(this.l, a);
    };
    LabelView.$t = markType(LabelView, 'LabelView');
    return LabelView;
}(Base));
export { LabelView };
/**
 * @hidden
 */
var InputView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputView, _super);
    function InputView() {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.j = null;
        _this.c = null;
        _this.h = new List$1(Delegate_$type, 0);
        _this.e = false;
        _this.p = null;
        _this.d = true;
        _this.k = null;
        _this.l = null;
        return _this;
    }
    InputView.prototype.ao = function () {
    };
    InputView.prototype.f = function () {
        return true;
    };
    Object.defineProperty(InputView.prototype, "o", {
        get: function () {
            return this.k;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputView.prototype, "a3", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputView.prototype, "g", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    InputView.prototype.al = function (a) {
        var e_9, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.h)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_9_1) {
                e_9 = { error: e_9_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_9)
                        throw e_9.error;
                }
            }
            this.h.clear();
        }
        this.j = a;
        this.j.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.j.createElement("input");
        c.setAttribute("type", this.b.b1);
        c.setStyleProperty("position", "relative");
        c.setStyleProperty("box-sizing", "border-box");
        c.setStyleProperty("display", "inline-block");
        c.setStyleProperty("border", "none");
        c.setStyleProperty("height", "2rem");
        c.setStyleProperty("line-height", "0");
        c.setStyleProperty("width", "100%");
        c.setStyleProperty("min-width", "0");
        c.setStyleProperty("overflow", "visible");
        c.setStyleProperty("background", "transparent");
        c.setStyleProperty("background-position-x", "initial");
        c.setStyleProperty("background-position-y", "initial");
        c.setStyleProperty("background-size", "initial");
        c.setStyleProperty("background-repeat-x", "initial");
        c.setStyleProperty("background-repeat-y", "initial");
        c.setStyleProperty("background-attachment", "initial");
        c.setStyleProperty("background-origin", "initial");
        c.setStyleProperty("background-color", "transparent");
        NativeUI.n(c, this.b.dr);
        c.setStyleProperty("outline-style", "none");
        c.setStyleProperty("box-shadow", "none");
        c.setStyleProperty("border-top", "0.1875rem solid transparent");
        c.setStyleProperty("padding-bottom", "0.1875rem");
        c.setStyleProperty("font-family", "'Segoe UI', Verdana");
        c.setStyleProperty("font-size", "1rem");
        this.h.add(c.listen("change", runOn(this, this.v)));
        this.h.add(c.listen("input", runOn(this, this.w)));
        this.h.add(c.listen("focus", runOn(this, this.ab)));
        this.h.add(c.listen("blur", runOn(this, this.u)));
        this.h.add(c.listen("mouseenter", runOn(this, this.s)));
        this.h.add(c.listen("mouseleave", runOn(this, this.t)));
        this.h.add(c.listen("keydown", runOn(this, this.ac)));
        this.h.add(c.listen("keyup", runOn(this, this.ae)));
        this.h.add(c.listen("keypress", runOn(this, this.ad)));
        this.h.add(c.listen("paste", runOn(this, this.ah)));
        this.h.add(c.listen("dragenter", runOn(this, this.z)));
        this.h.add(c.listen("dragleave", runOn(this, this.aa)));
        this.h.add(c.listen("compositionstart", runOn(this, this.y)));
        this.h.add(c.listen("compositionend", runOn(this, this.x)));
        this.h.add(c.listen("mousedown", runOn(this, this.af)));
        this.h.add(c.listen("mouseup", runOn(this, this.ag)));
        this.k = c;
        this.j.append(this.k);
        this.b.da();
    };
    InputView.prototype.au = function (a) {
        this.k.setAttribute("readonly", a.toString());
    };
    InputView.prototype.y = function (a) {
        this.e = true;
        this.b.cs();
    };
    InputView.prototype.x = function (a) {
        this.e = false;
        this.b.cr();
    };
    InputView.prototype.as = function () {
        this.k.setAttribute("type", this.b.b1);
        if (this.b.b1 == "date") {
            this.k.setStyleProperty("line-height", "normal");
        }
        else {
            this.k.setStyleProperty("line-height", "0");
        }
    };
    InputView.prototype.aq = function () {
        this.k.setAttribute("placeholder", this.b.b8);
    };
    InputView.prototype.az = function () {
        switch (this.b.l) {
            case 1:
                this.k.setStyleProperty("height", "2rem");
                this.k.setStyleProperty("font-size", "1rem");
                break;
            case 2:
                this.k.setStyleProperty("height", "1.68421rem");
                this.k.setStyleProperty("font-size", "1rem");
                break;
            case 3:
                this.k.setStyleProperty("height", "1.45455rem");
                this.k.setStyleProperty("font-size", ".95455rem");
                break;
        }
    };
    InputView.prototype.ay = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.b.r == 2 ? (_this.i() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.z(this.j.rootWrapper, a);
        this.j.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    InputView.prototype.i = function () {
        var a = this.j.rootWrapper.getStyleProperty("height");
        var b = parseFloat(stringReplace(a, "px", ""));
        return b;
    };
    InputView.prototype.at = function (a) {
        this.k.setProperty("value", a);
    };
    InputView.prototype.u = function (a) {
        this.b.co();
    };
    InputView.prototype.ab = function (a) {
        this.b.cw();
    };
    InputView.prototype.af = function (a) {
        var b = this.a2(a);
        this.b.c2(b);
        if (b.handled) {
            a.preventDefault();
        }
    };
    InputView.prototype.ag = function (a) {
        var b = this.a2(a);
        this.b.c5(b);
        if (b.handled) {
            a.preventDefault();
        }
    };
    InputView.prototype.a2 = function (a) {
        var b = new MouseButtonEventArgs();
        b.position = { $type: Point_$type, x: a.offsetX, y: a.offsetY };
        return b;
    };
    InputView.prototype.v = function (a) {
        this.b.cp();
    };
    InputView.prototype.w = function (a) {
        this.b.cq();
    };
    InputView.prototype.ac = function (a) {
        var b = new KeyEventArgs(0, a);
        this.b.cz(b);
    };
    InputView.prototype.ae = function (a) {
        var b = new KeyEventArgs(0, a);
        this.b.c1(b);
    };
    InputView.prototype.ad = function (a) {
        var b = new KeyEventArgs(0, a);
        this.b.c0(b);
    };
    InputView.prototype.ah = function (a) {
        this.b.c6();
    };
    InputView.prototype.z = function (a) {
        this.b.cu();
    };
    InputView.prototype.aa = function (a) {
        this.b.cv();
    };
    InputView.prototype.a0 = function (a) {
        if (this.p != a) {
            this.p = a;
            if (this.l != null) {
                this.l.setAttribute("d", this.p);
            }
        }
    };
    InputView.prototype.q = function () {
        return this.k.getProperty("value");
    };
    InputView.prototype.r = function (a) {
    };
    InputView.prototype.n = function () {
        var a = this.k.getProperty("selectionStart");
        return typeGetValue(a);
    };
    InputView.prototype.m = function () {
        var a = this.k.getProperty("selectionEnd");
        return typeGetValue(a);
    };
    InputView.prototype.ax = function (a) {
        this.k.setProperty("selectionStart", a);
    };
    InputView.prototype.av = function (a) {
        this.k.setProperty("selectionEnd", a);
    };
    InputView.prototype.ap = function () {
        if (this.f()) {
        }
    };
    InputView.prototype.s = function (a) {
        this.b.c3();
    };
    InputView.prototype.t = function (a) {
        this.b.c4();
    };
    InputView.prototype.aj = function () {
        this.d = true;
        this.h.add(this.k.listen("change", runOn(this, this.v)));
        this.h.add(this.k.listen("input", runOn(this, this.w)));
        this.h.add(this.k.listen("focus", runOn(this, this.ab)));
        this.h.add(this.k.listen("blur", runOn(this, this.u)));
        this.h.add(this.k.listen("mouseenter", runOn(this, this.s)));
        this.h.add(this.k.listen("mouseleave", runOn(this, this.t)));
        this.h.add(this.k.listen("keydown", runOn(this, this.ac)));
        this.h.add(this.k.listen("paste", runOn(this, this.ah)));
        this.h.add(this.k.listen("dragenter", runOn(this, this.z)));
        this.h.add(this.k.listen("dragleave", runOn(this, this.aa)));
        this.h.add(this.k.listen("compositionstart", runOn(this, this.y)));
        this.h.add(this.k.listen("compositionend", runOn(this, this.x)));
        this.h.add(this.k.listen("mousedown", runOn(this, this.af)));
        this.h.add(this.k.listen("mouseup", runOn(this, this.ag)));
    };
    InputView.prototype.am = function () {
        var e_10, _a;
        this.d = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.h)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_10_1) {
            e_10 = { error: e_10_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_10)
                    throw e_10.error;
            }
        }
        this.h.clear();
    };
    InputView.prototype.a1 = function (a) {
        if (a != null) {
            this.k.setStyleProperty("font", a.fontString);
        }
    };
    InputView.prototype.ak = function () {
        if (this.k != null) {
            var a = this.k.getNativeElement();
            a.blur();
        }
    };
    InputView.prototype.an = function (a) {
        if (this.k != null) {
            this.k.focus(a);
        }
    };
    InputView.prototype.ar = function () {
        if (this.k != null) {
            var nativeInput_ = this.k;
            nativeInput_.getNativeElement().select();
        }
    };
    InputView.prototype.aw = function (a, b) {
        if (this.k != null) {
            var c = this.k.getNativeElement();
            c.setSelectionRange(a, b);
        }
    };
    InputView.prototype.ai = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.j;
        }
    };
    InputView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.j.rootWrapper, 0, null, a);
    };
    InputView.$t = markType(InputView, 'InputView');
    return InputView;
}(Base));
export { InputView };
/**
 * @hidden
 */
var InputGroupItem = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputGroupItem, _super);
    function InputGroupItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.c = null;
        _this.a = null;
        _this.propertyChanged = null;
        return _this;
    }
    Object.defineProperty(InputGroupItem.prototype, "e", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.g("Name", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroupItem.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.g("InputGroup", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    InputGroupItem.prototype.g = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.h(a, b, c);
    };
    InputGroupItem.prototype.h = function (a, b, c) {
    };
    InputGroupItem.$t = markType(InputGroupItem, 'InputGroupItem', Base.$, [INotifyPropertyChanged_$type]);
    return InputGroupItem;
}(Base));
export { InputGroupItem };
/**
 * @hidden
 */
var Suffix = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Suffix, _super);
    function Suffix() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.j = 0;
        _this.v = "ig-suffix-" + Suffix.s++;
        _this.u = null;
        _this.n = false;
        _this.m = false;
        _this.o = false;
        var a = new SuffixView();
        a.a = _this;
        _this.view = a;
        _this.view.o();
        return _this;
    }
    Object.defineProperty(Suffix.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Suffix.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(Suffix.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("ShiftType", enumGetBox(SuffixShiftType_$type, b), enumGetBox(SuffixShiftType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Suffix.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "InputGroup":
                this.ai();
                break;
            case "ShiftType":
                this.al();
                break;
        }
    };
    Suffix.prototype.al = function () {
        this.view.q();
    };
    Suffix.prototype.ai = function () {
        this.view.q();
    };
    Suffix.prototype.ap = function () {
    };
    Suffix.prototype.ao = function () {
    };
    Suffix.prototype.aj = function () {
        this.q = true;
    };
    Suffix.prototype.ak = function () {
        this.q = false;
    };
    Object.defineProperty(Suffix.prototype, "z", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.g("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suffix.prototype, "w", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (b != this.u) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suffix.prototype, "q", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suffix.prototype, "disabled", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Suffix.prototype.am = function () {
    };
    Suffix.prototype.onDetachedFromUI = function () {
        this.view.n();
    };
    Suffix.prototype.onAttachedToUI = function () {
        this.view.l();
    };
    Suffix.prototype.r = function () {
        return this.view.d();
    };
    Suffix.prototype.t = function () {
        return this.i();
    };
    Suffix.prototype.y = function () {
        var a = this.i();
        return a.e();
    };
    Suffix.prototype.i = function () {
        var a = new SuffixVisualModelExport();
        a.a = this.k;
        a.c = this.q;
        a.b = this.disabled;
        a.d = this.e;
        return a;
    };
    Suffix.prototype.appendContentChild = function (a) {
        this.view.k(a);
    };
    Suffix.prototype.provideContainer = function (a) {
        this.view.m(a);
    };
    Suffix.$t = markType(Suffix, 'Suffix', InputGroupItem.$);
    Suffix.s = 0;
    return Suffix;
}(InputGroupItem));
export { Suffix };
/**
 * @hidden
 */
var Prefix = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Prefix, _super);
    function Prefix() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.j = 0;
        _this.v = "ig-prefix-" + Prefix.s++;
        _this.u = null;
        _this.n = false;
        _this.m = false;
        _this.o = false;
        var a = new PrefixView();
        a.a = _this;
        _this.view = a;
        _this.view.o();
        return _this;
    }
    Object.defineProperty(Prefix.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Prefix.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(Prefix.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("ShiftType", enumGetBox(PrefixShiftType_$type, b), enumGetBox(PrefixShiftType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Prefix.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "InputGroup":
                this.ai();
                break;
            case "ShiftType":
                this.al();
                break;
        }
    };
    Prefix.prototype.al = function () {
        this.view.q();
    };
    Prefix.prototype.ai = function () {
        this.view.q();
    };
    Prefix.prototype.ap = function () {
    };
    Prefix.prototype.ao = function () {
    };
    Prefix.prototype.aj = function () {
        this.q = true;
    };
    Prefix.prototype.ak = function () {
        this.q = false;
    };
    Object.defineProperty(Prefix.prototype, "z", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.g("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Prefix.prototype, "w", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (b != this.u) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Prefix.prototype, "q", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Prefix.prototype, "disabled", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Prefix.prototype.am = function () {
    };
    Prefix.prototype.onDetachedFromUI = function () {
        this.view.n();
    };
    Prefix.prototype.onAttachedToUI = function () {
        this.view.l();
    };
    Prefix.prototype.r = function () {
        return this.view.d();
    };
    Prefix.prototype.t = function () {
        return this.i();
    };
    Prefix.prototype.y = function () {
        var a = this.i();
        return a.e();
    };
    Prefix.prototype.i = function () {
        var a = new PrefixVisualModelExport();
        a.a = this.k;
        a.c = this.q;
        a.b = this.disabled;
        a.d = this.e;
        return a;
    };
    Prefix.prototype.appendContentChild = function (a) {
        this.view.k(a);
    };
    Prefix.prototype.provideContainer = function (a) {
        this.view.m(a);
    };
    Prefix.$t = markType(Prefix, 'Prefix', InputGroupItem.$);
    Prefix.s = 0;
    return Prefix;
}(InputGroupItem));
export { Prefix };
/**
 * @hidden
 */
var InputGroup = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputGroup, _super);
    function InputGroup() {
        var _this = _super.call(this) || this;
        _this.j = 0;
        _this.f = 1;
        _this.e = 1;
        _this.ad = false;
        _this.b = 0;
        _this._view = null;
        _this.q = null;
        _this.o = null;
        _this.lostFocus = null;
        _this.gotFocus = null;
        _this.df = ThemeResolver.b(InputGroup.c, InputGroup.fu, InputGroup.d1);
        _this.e5 = ThemeResolver.b(InputGroup.c, InputGroup.f5, InputGroup.ec);
        _this.m6 = ThemeResolver.d(InputGroup.c, InputGroup.nf, InputGroup.m9);
        _this.tm = ThemeResolver.f(InputGroup.c, InputGroup.tv, InputGroup.tp);
        _this.pf = ThemeResolver.e(InputGroup.c, InputGroup.rd, InputGroup.px);
        _this.q0 = ThemeResolver.e(InputGroup.c, InputGroup.ru, InputGroup.qe);
        _this.q1 = ThemeResolver.e(InputGroup.c, InputGroup.rv, InputGroup.qf);
        _this.hb = ThemeResolver.b(InputGroup.c, InputGroup.gx, InputGroup.e4);
        _this.ha = ThemeResolver.b(InputGroup.c, InputGroup.gw, InputGroup.e3);
        _this.e9 = ThemeResolver.b(InputGroup.c, InputGroup.f9, InputGroup.eg);
        _this.so = ThemeResolver.e(InputGroup.c, InputGroup.se, InputGroup.qy);
        _this.sp = ThemeResolver.e(InputGroup.c, InputGroup.sf, InputGroup.qz);
        _this.q3 = ThemeResolver.e(InputGroup.c, InputGroup.rx, InputGroup.qh);
        _this.q2 = ThemeResolver.e(InputGroup.c, InputGroup.rw, InputGroup.qg);
        _this.g8 = ThemeResolver.b(InputGroup.c, InputGroup.gu, InputGroup.e1);
        _this.e8 = ThemeResolver.b(InputGroup.c, InputGroup.f8, InputGroup.ef);
        _this.e6 = ThemeResolver.b(InputGroup.c, InputGroup.f6, InputGroup.ed);
        _this.e7 = ThemeResolver.b(InputGroup.c, InputGroup.f7, InputGroup.ee);
        _this.g9 = ThemeResolver.b(InputGroup.c, InputGroup.gv, InputGroup.e2);
        _this.pe = ThemeResolver.e(InputGroup.c, InputGroup.rc, InputGroup.pw);
        _this.fa = ThemeResolver.b(InputGroup.c, InputGroup.ga, InputGroup.eh);
        _this.fb = ThemeResolver.b(InputGroup.c, InputGroup.gb, InputGroup.ei);
        _this.nc = ThemeResolver.d(InputGroup.c, InputGroup.ng, InputGroup.na);
        _this.ts = ThemeResolver.f(InputGroup.c, InputGroup.tw, InputGroup.tq);
        _this.q5 = ThemeResolver.e(InputGroup.c, InputGroup.rz, InputGroup.qj);
        _this.q6 = ThemeResolver.e(InputGroup.c, InputGroup.r0, InputGroup.qk);
        _this.q7 = ThemeResolver.e(InputGroup.c, InputGroup.r1, InputGroup.ql);
        _this.fj = ThemeResolver.b(InputGroup.c, InputGroup.gj, InputGroup.eq);
        _this.fi = ThemeResolver.b(InputGroup.c, InputGroup.gi, InputGroup.ep);
        _this.ff = ThemeResolver.b(InputGroup.c, InputGroup.gf, InputGroup.em);
        _this.ra = ThemeResolver.e(InputGroup.c, InputGroup.r4, InputGroup.qo);
        _this.rb = ThemeResolver.e(InputGroup.c, InputGroup.r5, InputGroup.qp);
        _this.q9 = ThemeResolver.e(InputGroup.c, InputGroup.r3, InputGroup.qn);
        _this.q8 = ThemeResolver.e(InputGroup.c, InputGroup.r2, InputGroup.qm);
        _this.fg = ThemeResolver.b(InputGroup.c, InputGroup.gg, InputGroup.en);
        _this.fe = ThemeResolver.b(InputGroup.c, InputGroup.ge, InputGroup.el);
        _this.fc = ThemeResolver.b(InputGroup.c, InputGroup.gc, InputGroup.ej);
        _this.fd = ThemeResolver.b(InputGroup.c, InputGroup.gd, InputGroup.ek);
        _this.fh = ThemeResolver.b(InputGroup.c, InputGroup.gh, InputGroup.eo);
        _this.q4 = ThemeResolver.e(InputGroup.c, InputGroup.ry, InputGroup.qi);
        _this.dg = ThemeResolver.b(InputGroup.c, InputGroup.fv, InputGroup.d2);
        _this.dh = ThemeResolver.b(InputGroup.c, InputGroup.fw, InputGroup.d3);
        _this.m5 = ThemeResolver.d(InputGroup.c, InputGroup.ne, InputGroup.m8);
        _this.tl = ThemeResolver.f(InputGroup.c, InputGroup.tu, InputGroup.to);
        _this.pp = ThemeResolver.e(InputGroup.c, InputGroup.rn, InputGroup.p7);
        _this.pq = ThemeResolver.e(InputGroup.c, InputGroup.ro, InputGroup.p8);
        _this.pr = ThemeResolver.e(InputGroup.c, InputGroup.rp, InputGroup.p9);
        _this.dq = ThemeResolver.b(InputGroup.c, InputGroup.f4, InputGroup.eb);
        _this.dp = ThemeResolver.b(InputGroup.c, InputGroup.f3, InputGroup.ea);
        _this.dl = ThemeResolver.b(InputGroup.c, InputGroup.f0, InputGroup.d7);
        _this.pu = ThemeResolver.e(InputGroup.c, InputGroup.rs, InputGroup.qc);
        _this.pv = ThemeResolver.e(InputGroup.c, InputGroup.rt, InputGroup.qd);
        _this.pt = ThemeResolver.e(InputGroup.c, InputGroup.rr, InputGroup.qb);
        _this.ps = ThemeResolver.e(InputGroup.c, InputGroup.rq, InputGroup.qa);
        _this.dm = ThemeResolver.b(InputGroup.c, InputGroup.f1, InputGroup.d8);
        _this.dk = ThemeResolver.b(InputGroup.c, InputGroup.fz, InputGroup.d6);
        _this.di = ThemeResolver.b(InputGroup.c, InputGroup.fx, InputGroup.d4);
        _this.dj = ThemeResolver.b(InputGroup.c, InputGroup.fy, InputGroup.d5);
        _this.dn = ThemeResolver.b(InputGroup.c, InputGroup.f2, InputGroup.d9);
        _this.po = ThemeResolver.e(InputGroup.c, InputGroup.rm, InputGroup.p6);
        _this.c5 = ThemeResolver.b(InputGroup.c, InputGroup.fk, InputGroup.dr);
        _this.c6 = ThemeResolver.b(InputGroup.c, InputGroup.fl, InputGroup.ds);
        _this.m4 = ThemeResolver.d(InputGroup.c, InputGroup.nd, InputGroup.m7);
        _this.tk = ThemeResolver.f(InputGroup.c, InputGroup.tt, InputGroup.tn);
        _this.ph = ThemeResolver.e(InputGroup.c, InputGroup.rf, InputGroup.pz);
        _this.pi = ThemeResolver.e(InputGroup.c, InputGroup.rg, InputGroup.p0);
        _this.pj = ThemeResolver.e(InputGroup.c, InputGroup.rh, InputGroup.p1);
        _this.de = ThemeResolver.b(InputGroup.c, InputGroup.ft, InputGroup.d0);
        _this.dd = ThemeResolver.b(InputGroup.c, InputGroup.fs, InputGroup.dz);
        _this.da = ThemeResolver.b(InputGroup.c, InputGroup.fp, InputGroup.dw);
        _this.pm = ThemeResolver.e(InputGroup.c, InputGroup.rk, InputGroup.p4);
        _this.pn = ThemeResolver.e(InputGroup.c, InputGroup.rl, InputGroup.p5);
        _this.pl = ThemeResolver.e(InputGroup.c, InputGroup.rj, InputGroup.p3);
        _this.pk = ThemeResolver.e(InputGroup.c, InputGroup.ri, InputGroup.p2);
        _this.db = ThemeResolver.b(InputGroup.c, InputGroup.fq, InputGroup.dx);
        _this.c9 = ThemeResolver.b(InputGroup.c, InputGroup.fo, InputGroup.dv);
        _this.c7 = ThemeResolver.b(InputGroup.c, InputGroup.fm, InputGroup.dt);
        _this.c8 = ThemeResolver.b(InputGroup.c, InputGroup.fn, InputGroup.du);
        _this.dc = ThemeResolver.b(InputGroup.c, InputGroup.fr, InputGroup.dy);
        _this.pg = ThemeResolver.e(InputGroup.c, InputGroup.re, InputGroup.py);
        _this.gy = ThemeResolver.b(InputGroup.c, InputGroup.gk, InputGroup.er);
        _this.gz = ThemeResolver.b(InputGroup.c, InputGroup.gl, InputGroup.es);
        _this.ni = ThemeResolver.d(InputGroup.c, InputGroup.nh, InputGroup.nb);
        _this.ty = ThemeResolver.f(InputGroup.c, InputGroup.tx, InputGroup.tr);
        _this.sh = ThemeResolver.e(InputGroup.c, InputGroup.r7, InputGroup.qr);
        _this.si = ThemeResolver.e(InputGroup.c, InputGroup.r8, InputGroup.qs);
        _this.sj = ThemeResolver.e(InputGroup.c, InputGroup.r9, InputGroup.qt);
        _this.g7 = ThemeResolver.b(InputGroup.c, InputGroup.gt, InputGroup.e0);
        _this.g6 = ThemeResolver.b(InputGroup.c, InputGroup.gs, InputGroup.ez);
        _this.g3 = ThemeResolver.b(InputGroup.c, InputGroup.gp, InputGroup.ew);
        _this.sm = ThemeResolver.e(InputGroup.c, InputGroup.sc, InputGroup.qw);
        _this.sn = ThemeResolver.e(InputGroup.c, InputGroup.sd, InputGroup.qx);
        _this.sl = ThemeResolver.e(InputGroup.c, InputGroup.sb, InputGroup.qv);
        _this.sk = ThemeResolver.e(InputGroup.c, InputGroup.sa, InputGroup.qu);
        _this.g4 = ThemeResolver.b(InputGroup.c, InputGroup.gq, InputGroup.ex);
        _this.g2 = ThemeResolver.b(InputGroup.c, InputGroup.go, InputGroup.ev);
        _this.g0 = ThemeResolver.b(InputGroup.c, InputGroup.gm, InputGroup.et);
        _this.g1 = ThemeResolver.b(InputGroup.c, InputGroup.gn, InputGroup.eu);
        _this.g5 = ThemeResolver.b(InputGroup.c, InputGroup.gr, InputGroup.ey);
        _this.sg = ThemeResolver.e(InputGroup.c, InputGroup.r6, InputGroup.qq);
        _this.nm = ThemeResolver.e(InputGroup.c, InputGroup.rd, InputGroup.px);
        _this.nn = ThemeResolver.e(InputGroup.c, InputGroup.ru, InputGroup.qe);
        _this.am = ThemeResolver.b(InputGroup.c, InputGroup.fu, InputGroup.d1);
        _this.an = ThemeResolver.b(InputGroup.c, InputGroup.f5, InputGroup.ec);
        _this.mt = ThemeResolver.d(InputGroup.c, InputGroup.nf, InputGroup.m9);
        _this.s9 = ThemeResolver.f(InputGroup.c, InputGroup.tv, InputGroup.tp);
        _this.av = ThemeResolver.b(InputGroup.c, InputGroup.gx, InputGroup.e4);
        _this.au = ThemeResolver.b(InputGroup.c, InputGroup.gw, InputGroup.e3);
        _this.ar = ThemeResolver.b(InputGroup.c, InputGroup.f9, InputGroup.eg);
        _this.nq = ThemeResolver.e(InputGroup.c, InputGroup.se, InputGroup.qy);
        _this.nr = ThemeResolver.e(InputGroup.c, InputGroup.sf, InputGroup.qz);
        _this.np = ThemeResolver.e(InputGroup.c, InputGroup.rx, InputGroup.qh);
        _this.no = ThemeResolver.e(InputGroup.c, InputGroup.rw, InputGroup.qg);
        _this.as = ThemeResolver.b(InputGroup.c, InputGroup.gu, InputGroup.e1);
        _this.aq = ThemeResolver.b(InputGroup.c, InputGroup.f8, InputGroup.ef);
        _this.ao = ThemeResolver.b(InputGroup.c, InputGroup.f6, InputGroup.ed);
        _this.ap = ThemeResolver.b(InputGroup.c, InputGroup.f7, InputGroup.ee);
        _this.at = ThemeResolver.b(InputGroup.c, InputGroup.gv, InputGroup.e2);
        _this.nl = ThemeResolver.e(InputGroup.c, InputGroup.rc, InputGroup.pw);
        _this.a6 = NaN;
        _this.bh = NaN;
        _this.nt = null;
        _this.mw = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.tc = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.b9 = NaN;
        _this.b8 = NaN;
        _this.bl = NaN;
        _this.op = null;
        _this.oq = null;
        _this.oa = null;
        _this.n9 = null;
        _this.b6 = NaN;
        _this.bk = NaN;
        _this.bi = NaN;
        _this.bj = NaN;
        _this.b7 = NaN;
        _this.ns = null;
        _this.bm = NaN;
        _this.bn = NaN;
        _this.od = null;
        _this.oc = null;
        _this.mx = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.td = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.bv = NaN;
        _this.bu = NaN;
        _this.br = NaN;
        _this.og = null;
        _this.oh = null;
        _this.of = null;
        _this.oe = null;
        _this.bs = NaN;
        _this.bq = NaN;
        _this.bo = NaN;
        _this.bp = NaN;
        _this.bt = NaN;
        _this.ob = null;
        _this.a7 = NaN;
        _this.a8 = NaN;
        _this.n3 = null;
        _this.n2 = null;
        _this.mv = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.tb = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.bg = NaN;
        _this.bf = NaN;
        _this.bc = NaN;
        _this.n6 = null;
        _this.n7 = null;
        _this.n5 = null;
        _this.n4 = null;
        _this.bd = NaN;
        _this.bb = NaN;
        _this.a9 = NaN;
        _this.ba = NaN;
        _this.be = NaN;
        _this.n1 = null;
        _this.aw = NaN;
        _this.ax = NaN;
        _this.nw = null;
        _this.nv = null;
        _this.mu = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.ta = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.a5 = NaN;
        _this.a4 = NaN;
        _this.a1 = NaN;
        _this.nz = null;
        _this.n0 = null;
        _this.ny = null;
        _this.nx = null;
        _this.a2 = NaN;
        _this.a0 = NaN;
        _this.ay = NaN;
        _this.az = NaN;
        _this.a3 = NaN;
        _this.nu = null;
        _this.bw = NaN;
        _this.bx = NaN;
        _this.ok = null;
        _this.oj = null;
        _this.my = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.te = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.b5 = NaN;
        _this.b4 = NaN;
        _this.b1 = NaN;
        _this.on = null;
        _this.oo = null;
        _this.om = null;
        _this.ol = null;
        _this.b2 = NaN;
        _this.b0 = NaN;
        _this.by = NaN;
        _this.bz = NaN;
        _this.b3 = NaN;
        _this.oi = null;
        _this.x = false;
        _this.t = false;
        _this.z = false;
        _this.v = false;
        _this.y = false;
        _this.u = false;
        _this.r = false;
        _this.n8 = null;
        _this.ib = "ig-inputgroup-" + InputGroup.h8++;
        _this.w = false;
        _this.propertyChanged = null;
        _this.l = new InputGroupInputCollection();
        _this.p = null;
        _this.ab = false;
        _this.s = false;
        _this.aa = false;
        _this.h9 = toNullable(Number_$type, null);
        var a = new InputGroupView();
        a.d = _this;
        _this.view = a;
        _this.view.ak();
        var b = _this.l;
        b.collectionChanged = delegateCombine(b.collectionChanged, runOn(_this, _this.lx));
        var c = _this.l;
        c.collectionResetting = delegateCombine(c.collectionResetting, runOn(_this, _this.ly));
        return _this;
    }
    InputGroup.prototype.ly = function (a, b) {
        this.mm();
        this.view.ad();
    };
    InputGroup.prototype.appendContentChild = function (a) {
        this.view.ab(a);
    };
    InputGroup.prototype.mi = function (a) {
        this.view.an(a);
    };
    Object.defineProperty(InputGroup.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.md("DisplayType", enumGetBox(InputGroupDisplayType_$type, b), enumGetBox(InputGroupDisplayType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (b != this.f) {
                this.md("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "g", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (b != this.e) {
                this.md("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.l3 = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Label.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    InputGroup.prototype.l4 = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Prefix.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    InputGroup.prototype.l2 = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Input.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    InputGroup.prototype.l5 = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Suffix.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    InputGroup.prototype.lx = function (a, b) {
        var e_11, _a, e_12, _b;
        if (b.oldItems != null) {
            try {
                for (var _c = tslib_1.__values(fromEn(b.oldItems)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var c = _d.value;
                    var d = c;
                    if (d != null) {
                        d.b = null;
                    }
                    this.view.ae(d);
                }
            }
            catch (e_11_1) {
                e_11 = { error: e_11_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_11)
                        throw e_11.error;
                }
            }
        }
        if (b.newItems != null) {
            try {
                for (var _e = tslib_1.__values(fromEn(b.newItems)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var e = _f.value;
                    var f = e;
                    if (f != null) {
                        f.b = this;
                    }
                    this.view.ac(f);
                }
            }
            catch (e_12_1) {
                e_12 = { error: e_12_1 };
            }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return))
                        _b.call(_e);
                }
                finally {
                    if (e_12)
                        throw e_12.error;
                }
            }
        }
        this.mk();
        this.ad = true;
        try {
            this.ms();
        }
        finally {
            this.ad = false;
        }
        this.mp();
        this.mo();
        this.mq();
        this.mr();
        this.mm();
    };
    Object.defineProperty(InputGroup.prototype, "d", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.md("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.destroy = function () {
        this.provideContainer(null);
    };
    InputGroup.prototype.md = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.mg(a, b, c);
    };
    InputGroup.prototype.mg = function (a, b, c) {
        var _this = this;
        switch (a) {
            case "BaseTheme":
                this.ml(this.d);
                this.mn();
                this.l3(function (d) { return d.l = _this.d == 0 ? 2 : _this.d; });
                break;
            case "ActualBorderColor":
            case "ActualBackgroundColor":
            case "ActualBorderWidth":
            case "ActualFocusBorderColor":
            case "ActualFocusBorderWidth":
            case "ActualCornerRadius":
            case "ActualContentPadding":
            case "ActualUnderlineOpacity":
            case "ActualUnderlineRippleOpacity":
            case "ActualUnderlineRippleWidth":
            case "ActualUnderlineRippleColor":
            case "ActualUnderlineColor":
            case "ActualHoverUnderlineColor":
            case "ActualUnderlineWidth":
            case "ActualHoverUnderlineWidth":
            case "ActualHoverUnderlineOpacity":
            case "ActualFocusUnderlineColor":
            case "ActualFocusUnderlineOpacity":
            case "ActualFocusUnderlineRippleOpacity":
            case "IsHovered":
                this.aa = true;
                this.ab = true;
                this.s = true;
                this.mm();
                break;
            case "BorderColor":
            case "BackgroundColor":
            case "BorderWidth":
            case "FocusBorderColor":
            case "FocusBorderWidth":
            case "CornerRadius":
            case "ContentPadding":
            case "UnderlineOpacity":
            case "UnderlineRippleOpacity":
            case "UnderlineRippleWidth":
            case "UnderlineRippleColor":
            case "UnderlineColor":
            case "HoverUnderlineColor":
            case "UnderlineWidth":
            case "HoverUnderlineWidth":
            case "HoverUnderlineOpacity":
            case "FocusUnderlineColor":
            case "FocusUnderlineOpacity":
            case "FocusUnderlineRippleOpacity":
            case "LineTypeBorderColor":
            case "LineTypeBackgroundColor":
            case "LineTypeBorderWidth":
            case "LineTypeFocusBorderColor":
            case "LineTypeFocusBorderWidth":
            case "LineTypeCornerRadius":
            case "LineTypeContentPadding":
            case "LineTypeUnderlineOpacity":
            case "LineTypeUnderlineRippleOpacity":
            case "LineTypeUnderlineRippleWidth":
            case "LineTypeUnderlineRippleColor":
            case "LineTypeUnderlineColor":
            case "LineTypeHoverUnderlineColor":
            case "LineTypeUnderlineWidth":
            case "LineTypeHoverUnderlineWidth":
            case "LineTypeHoverUnderlineOpacity":
            case "LineTypeFocusUnderlineColor":
            case "LineTypeFocusUnderlineOpacity":
            case "LineTypeFocusUnderlineRippleOpacity":
            case "BoxTypeBorderColor":
            case "BoxTypeBackgroundColor":
            case "BoxTypeBorderWidth":
            case "BoxTypeFocusBorderColor":
            case "BoxTypeFocusBorderWidth":
            case "BoxTypeCornerRadius":
            case "BoxTypeContentPadding":
            case "BoxTypeUnderlineOpacity":
            case "BoxTypeUnderlineRippleOpacity":
            case "BoxTypeUnderlineRippleWidth":
            case "BoxTypeUnderlineRippleColor":
            case "BoxTypeUnderlineColor":
            case "BoxTypeHoverUnderlineColor":
            case "BoxTypeUnderlineWidth":
            case "BoxTypeHoverUnderlineWidth":
            case "BoxTypeHoverUnderlineOpacity":
            case "BoxTypeFocusUnderlineColor":
            case "BoxTypeFocusUnderlineOpacity":
            case "BoxTypeFocusUnderlineRippleOpacity":
            case "BorderTypeBorderColor":
            case "BorderTypeBackgroundColor":
            case "BorderTypeBorderWidth":
            case "BorderTypeFocusBorderColor":
            case "BorderTypeFocusBorderWidth":
            case "BorderTypeCornerRadius":
            case "BorderTypeContentPadding":
            case "BorderTypeUnderlineOpacity":
            case "BorderTypeUnderlineRippleOpacity":
            case "BorderTypeUnderlineRippleWidth":
            case "BorderTypeUnderlineRippleColor":
            case "BorderTypeUnderlineColor":
            case "BorderTypeHoverUnderlineColor":
            case "BorderTypeUnderlineWidth":
            case "BorderTypeHoverUnderlineWidth":
            case "BorderTypeHoverUnderlineOpacity":
            case "BorderTypeFocusUnderlineColor":
            case "BorderTypeFocusUnderlineOpacity":
            case "BorderTypeFocusUnderlineRippleOpacity":
            case "DisplayType":
                this.mn();
                break;
            case "ActualDensity":
                this.view.ap();
                this.mn();
                break;
            case "Density":
                this.g = this.h == 0 ? 1 : this.h;
                break;
            case "IsFocused":
                this.mb();
                this.mm();
                break;
            case "IsExpanded":
                this.t = true;
                this.ac = this.ah;
                break;
            case "ActualIsExpanded":
                this.l6();
                break;
        }
    };
    InputGroup.m2 = function (a, b) {
        return new CornerRadius(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b, !isNaN_(a.a) ? a.a : b.a);
    };
    InputGroup.ti = function (a, b) {
        return new Thickness(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.e) ? a.e : b.e, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b);
    };
    InputGroup.prototype.mp = function () {
        var _this = this;
        this.l3(function (a) {
            a.p = _this.g;
            a.l = _this.d == 0 ? 2 : _this.d;
            switch (_this.k) {
                case 0:
                    a.s = 0;
                    break;
                case 1:
                    a.s = 1;
                    break;
                case 2:
                case 3:
                    a.s = 2;
                    break;
            }
            a.ch(_this.ac, false);
        });
    };
    InputGroup.prototype.mq = function () {
        var _this = this;
        this.l4(function (a) {
            switch (_this.k) {
                case 0:
                    a.k = 0;
                    break;
                case 1:
                    a.k = 1;
                    break;
                case 2:
                case 3:
                    a.k = 2;
                    break;
            }
        });
    };
    InputGroup.prototype.mo = function () {
        var _this = this;
        this.l2(function (a) {
            a.m = _this.g;
            switch (_this.k) {
                case 0:
                    a.r = 0;
                    break;
                case 1:
                    a.r = 1;
                    break;
                case 2:
                case 3:
                    a.r = 2;
                    break;
            }
            a.de(_this.al, false);
        });
    };
    InputGroup.prototype.mr = function () {
        var _this = this;
        this.l5(function (a) {
            switch (_this.k) {
                case 0:
                    a.k = 0;
                    break;
                case 1:
                    a.k = 1;
                    break;
                case 2:
                case 3:
                    a.k = 2;
                    break;
            }
        });
    };
    InputGroup.prototype.mn = function () {
        this.mp();
        this.mo();
        this.mq();
        this.mr();
        switch (this.k) {
            case 0:
                this.os = this.oz != null ? this.oz : this.su != null ? this.su : this.q5;
                this.or = this.oy != null ? this.oy : this.st != null ? this.st : this.q4;
                this.ca = !isNaN_(this.cu) ? this.cu : !isNaN_(this.hh) ? this.hh : this.fa;
                this.ot = this.sq != null ? this.sq : this.sv != null ? this.sv : this.q6;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.hi) ? this.hi : this.fb;
                this.mz = InputGroup.m2(this.m3, InputGroup.m2(this.nj, this.nc));
                this.tf = InputGroup.ti(this.tj, InputGroup.ti(this.tz, this.ts));
                this.cg = !isNaN_(this.h1) ? this.h1 : !isNaN_(this.hn) ? this.hn : this.fg;
                this.ch = !isNaN_(this.h2) ? this.h2 : !isNaN_(this.ho) ? this.ho : this.fh;
                this.ci = !isNaN_(this.h3) ? this.h3 : !isNaN_(this.hp) ? this.hp : this.fi;
                this.ox = this.s8 != null ? this.s8 : this.sz != null ? this.sz : this.rb;
                this.ow = this.s7 != null ? this.s7 : this.sy != null ? this.sy : this.ra;
                this.ov = this.ss != null ? this.ss : this.sx != null ? this.sx : this.q9;
                this.cj = !isNaN_(this.h4) ? this.h4 : !isNaN_(this.hq) ? this.hq : this.fj;
                this.cf = !isNaN_(this.hg) ? this.hg : !isNaN_(this.hm) ? this.hm : this.ff;
                this.ce = !isNaN_(this.hf) ? this.hf : !isNaN_(this.hl) ? this.hl : this.fe;
                this.ou = this.sr != null ? this.sr : this.sw != null ? this.sw : this.q8;
                this.cc = !isNaN_(this.hd) ? this.hd : !isNaN_(this.hj) ? this.hj : this.fc;
                this.cd = !isNaN_(this.he) ? this.he : !isNaN_(this.hk) ? this.hk : this.fd;
                break;
            case 1:
                this.os = this.oz != null ? this.oz : this.o8 != null ? this.o8 : this.pp;
                this.or = this.oy != null ? this.oy : this.o7 != null ? this.o7 : this.po;
                this.ca = !isNaN_(this.cu) ? this.cu : !isNaN_(this.cv) ? this.cv : this.dg;
                this.ot = this.sq != null ? this.sq : this.o9 != null ? this.o9 : this.pq;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.cw) ? this.cw : this.dh;
                this.mz = InputGroup.m2(this.m3, InputGroup.m2(this.m1, this.m5));
                this.tf = InputGroup.ti(this.tj, InputGroup.ti(this.th, this.tl));
                this.cg = !isNaN_(this.h1) ? this.h1 : !isNaN_(this.c1) ? this.c1 : this.dm;
                this.ch = !isNaN_(this.h2) ? this.h2 : !isNaN_(this.c2) ? this.c2 : this.dn;
                this.ci = !isNaN_(this.h3) ? this.h3 : !isNaN_(this.c3) ? this.c3 : this.dp;
                this.ox = this.s8 != null ? this.s8 : this.pd != null ? this.pd : this.pv;
                this.ow = this.s7 != null ? this.s7 : this.pc != null ? this.pc : this.pu;
                this.ov = this.ss != null ? this.ss : this.pb != null ? this.pb : this.pt;
                this.cj = !isNaN_(this.h4) ? this.h4 : !isNaN_(this.c4) ? this.c4 : this.dq;
                this.cf = !isNaN_(this.hg) ? this.hg : !isNaN_(this.c0) ? this.c0 : this.dl;
                this.ce = !isNaN_(this.hf) ? this.hf : !isNaN_(this.cz) ? this.cz : this.dk;
                this.ou = this.sr != null ? this.sr : this.pa != null ? this.pa : this.ps;
                this.cc = !isNaN_(this.hd) ? this.hd : !isNaN_(this.cx) ? this.cx : this.di;
                this.cd = !isNaN_(this.he) ? this.he : !isNaN_(this.cy) ? this.cy : this.dj;
                break;
            case 2:
                this.os = this.oz != null ? this.oz : this.o1 != null ? this.o1 : this.ph;
                this.or = this.oy != null ? this.oy : this.o0 != null ? this.o0 : this.pg;
                this.ca = !isNaN_(this.cu) ? this.cu : !isNaN_(this.ck) ? this.ck : this.c5;
                this.ot = this.sq != null ? this.sq : this.o2 != null ? this.o2 : this.pi;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.cl) ? this.cl : this.c6;
                this.mz = InputGroup.m2(this.m3, InputGroup.m2(this.m0, this.m4));
                this.tf = InputGroup.ti(this.tj, InputGroup.ti(this.tg, this.tk));
                this.cg = !isNaN_(this.h1) ? this.h1 : !isNaN_(this.cq) ? this.cq : this.db;
                this.ch = !isNaN_(this.h2) ? this.h2 : !isNaN_(this.cr) ? this.cr : this.dc;
                this.ci = !isNaN_(this.h3) ? this.h3 : !isNaN_(this.cs) ? this.cs : this.dd;
                this.ox = this.s8 != null ? this.s8 : this.o6 != null ? this.o6 : this.pn;
                this.ow = this.s7 != null ? this.s7 : this.o5 != null ? this.o5 : this.pm;
                this.ov = this.ss != null ? this.ss : this.o4 != null ? this.o4 : this.pl;
                this.cj = !isNaN_(this.h4) ? this.h4 : !isNaN_(this.ct) ? this.ct : this.de;
                this.cf = !isNaN_(this.hg) ? this.hg : !isNaN_(this.cp) ? this.cp : this.da;
                this.ce = !isNaN_(this.hf) ? this.hf : !isNaN_(this.co) ? this.co : this.c9;
                this.ou = this.sr != null ? this.sr : this.o3 != null ? this.o3 : this.pk;
                this.cc = !isNaN_(this.hd) ? this.hd : !isNaN_(this.cm) ? this.cm : this.c7;
                this.cd = !isNaN_(this.he) ? this.he : !isNaN_(this.cn) ? this.cn : this.c8;
                break;
            case 3:
                this.os = this.oz != null ? this.oz : this.s1 != null ? this.s1 : this.sh;
                this.or = this.oy != null ? this.oy : this.s0 != null ? this.s0 : this.sg;
                this.ca = !isNaN_(this.cu) ? this.cu : !isNaN_(this.hr) ? this.hr : this.gy;
                this.ot = this.sq != null ? this.sq : this.s2 != null ? this.s2 : this.si;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.hs) ? this.hs : this.gz;
                this.mz = InputGroup.m2(this.m3, InputGroup.m2(this.nk, this.ni));
                this.tf = InputGroup.ti(this.tj, InputGroup.ti(this.t0, this.ty));
                this.cg = !isNaN_(this.h1) ? this.h1 : !isNaN_(this.hx) ? this.hx : this.g4;
                this.ch = !isNaN_(this.h2) ? this.h2 : !isNaN_(this.hy) ? this.hy : this.g5;
                this.ci = !isNaN_(this.h3) ? this.h3 : !isNaN_(this.hz) ? this.hz : this.g6;
                this.ox = this.s8 != null ? this.s8 : this.s6 != null ? this.s6 : this.sn;
                this.ow = this.s7 != null ? this.s7 : this.s5 != null ? this.s5 : this.sm;
                this.ov = this.ss != null ? this.ss : this.s4 != null ? this.s4 : this.sl;
                this.cj = !isNaN_(this.h4) ? this.h4 : !isNaN_(this.h0) ? this.h0 : this.g7;
                this.cf = !isNaN_(this.hg) ? this.hg : !isNaN_(this.hw) ? this.hw : this.g3;
                this.ce = !isNaN_(this.hf) ? this.hf : !isNaN_(this.hv) ? this.hv : this.g2;
                this.ou = this.sr != null ? this.sr : this.s3 != null ? this.s3 : this.sk;
                this.cc = !isNaN_(this.hd) ? this.hd : !isNaN_(this.ht) ? this.ht : this.g0;
                this.cd = !isNaN_(this.he) ? this.he : !isNaN_(this.hu) ? this.hu : this.g1;
                break;
        }
    };
    InputGroup.prototype.mm = function () {
        this.l3(function (a) {
        });
        this.l2(function (a) {
        });
        var a = this.view.v;
        var b = this.view.u;
        var c = this.view.x;
        var d = this.view.y;
        var e = this.p != null && this.p.playState == 1;
        var f = this.q != null && this.q.playState == 1;
        var g = this.o != null && this.o.playState == 1;
        NativeUI.l(a, this.mz);
        NativeUI.l(b, this.mz);
        NativeUI.j(a, this.or);
        NativeUI.u(a, this.tf);
        if (this.ai) {
            if (!g) {
                NativeUI.k(b, this.ot);
                NativeUI.m(b, new Thickness(0, this.cb));
            }
            if (!f) {
                NativeUI.j(c, this.ou);
            }
        }
        else {
            if (!f) {
                if (this.aj) {
                    NativeUI.j(c, this.ov);
                    NativeUI.t(c, this.ce);
                    NativeUI.q(c, this.cf);
                }
                else {
                    NativeUI.j(c, this.ow);
                    NativeUI.t(c, this.cg);
                    NativeUI.q(c, this.cj);
                }
            }
            if (!g) {
                NativeUI.k(b, this.os);
                NativeUI.m(b, new Thickness(0, this.ca));
            }
            if (!f) {
                NativeUI.j(a, this.or);
            }
        }
        if (!e) {
            NativeUI.j(d, this.ox);
            NativeUI.q(d, this.ci);
            NativeUI.t(d, this.ch);
        }
    };
    Object.defineProperty(InputGroup.prototype, "a", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.onChildrenMutated = function () {
        this.l2(function (a) { return a.view.ay(); });
        this.l3(function (a) { return a.view.ae(); });
        this.l4(function (a) { return a.view.q(); });
        this.l5(function (a) { return a.view.q(); });
    };
    InputGroup.prototype.l1 = function () {
        this.view.af();
        var a = false;
        if (this.q == null) {
            this.q = KeyFrameAnimationFactory.f.c(this.view.c(this.a).m(new AnimationKeyFrameProperty(2, this.os)).m(new AnimationKeyFrameProperty(2, this.ot)));
        }
        if (this.o == null) {
            this.o = KeyFrameAnimationFactory.f.c(this.view.a(this.a).m(new AnimationKeyFrameProperty(3, this.os), new AnimationKeyFrameProperty(4, this.k == 2 || this.k == 3 ? new Thickness(0, this.ca) : new Thickness(0, 0))).m(new AnimationKeyFrameProperty(3, this.ot), new AnimationKeyFrameProperty(4, this.k == 2 || this.k == 3 ? new Thickness(0, this.cb) : new Thickness(0, 0))));
        }
        if (this.p == null) {
            this.p = KeyFrameAnimationFactory.f.c(this.view.b(this.a).m(new AnimationKeyFrameProperty(2, this.ot), new AnimationKeyFrameProperty(14, ((function () {
                var $ret = new ScaleTransform();
                $ret.l = 0.5;
                $ret.m = 1;
                return $ret;
            })())), new AnimationKeyFrameProperty(1, 0)).m(new AnimationKeyFrameProperty(2, this.ot), new AnimationKeyFrameProperty(14, ((function () {
                var $ret = new ScaleTransform();
                $ret.l = 1;
                $ret.m = 1;
                return $ret;
            })())), new AnimationKeyFrameProperty(1, 1)));
        }
    };
    Object.defineProperty(InputGroup.prototype, "af", {
        get: function () {
            var a = false;
            this.l2(function (b) {
                if (b.ao) {
                    a = true;
                }
            });
            return a;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.mc = function () {
        this.ac = this.t ? this.ah : this.af ? true : false;
        this.ai = false;
        if (null != this.lostFocus) {
            this.lostFocus(this, EventArgs.empty);
        }
    };
    InputGroup.prototype.ml = function (a) {
        this.df = ThemeResolver.b(a, InputGroup.fu, InputGroup.d1);
        this.e5 = ThemeResolver.b(a, InputGroup.f5, InputGroup.ec);
        this.m6 = ThemeResolver.d(a, InputGroup.nf, InputGroup.m9);
        this.tm = ThemeResolver.f(a, InputGroup.tv, InputGroup.tp);
        this.pf = ThemeResolver.e(a, InputGroup.rd, InputGroup.px);
        this.q0 = ThemeResolver.e(a, InputGroup.ru, InputGroup.qe);
        this.q1 = ThemeResolver.e(a, InputGroup.rv, InputGroup.qf);
        this.hb = ThemeResolver.b(a, InputGroup.gx, InputGroup.e4);
        this.ha = ThemeResolver.b(a, InputGroup.gw, InputGroup.e3);
        this.e9 = ThemeResolver.b(a, InputGroup.f9, InputGroup.eg);
        this.so = ThemeResolver.e(a, InputGroup.se, InputGroup.qy);
        this.sp = ThemeResolver.e(a, InputGroup.sf, InputGroup.qz);
        this.q3 = ThemeResolver.e(a, InputGroup.rx, InputGroup.qh);
        this.q2 = ThemeResolver.e(a, InputGroup.rw, InputGroup.qg);
        this.g8 = ThemeResolver.b(a, InputGroup.gu, InputGroup.e1);
        this.e8 = ThemeResolver.b(a, InputGroup.f8, InputGroup.ef);
        this.e6 = ThemeResolver.b(a, InputGroup.f6, InputGroup.ed);
        this.e7 = ThemeResolver.b(a, InputGroup.f7, InputGroup.ee);
        this.g9 = ThemeResolver.b(a, InputGroup.gv, InputGroup.e2);
        this.pe = ThemeResolver.e(a, InputGroup.rc, InputGroup.pw);
        this.fa = ThemeResolver.b(a, InputGroup.ga, InputGroup.eh);
        this.fb = ThemeResolver.b(a, InputGroup.gb, InputGroup.ei);
        this.nc = ThemeResolver.d(a, InputGroup.ng, InputGroup.na);
        this.ts = ThemeResolver.f(a, InputGroup.tw, InputGroup.tq);
        this.q5 = ThemeResolver.e(a, InputGroup.rz, InputGroup.qj);
        this.q6 = ThemeResolver.e(a, InputGroup.r0, InputGroup.qk);
        this.q7 = ThemeResolver.e(a, InputGroup.r1, InputGroup.ql);
        this.fj = ThemeResolver.b(a, InputGroup.gj, InputGroup.eq);
        this.fi = ThemeResolver.b(a, InputGroup.gi, InputGroup.ep);
        this.ff = ThemeResolver.b(a, InputGroup.gf, InputGroup.em);
        this.ra = ThemeResolver.e(a, InputGroup.r4, InputGroup.qo);
        this.rb = ThemeResolver.e(a, InputGroup.r5, InputGroup.qp);
        this.q9 = ThemeResolver.e(a, InputGroup.r3, InputGroup.qn);
        this.q8 = ThemeResolver.e(a, InputGroup.r2, InputGroup.qm);
        this.fg = ThemeResolver.b(a, InputGroup.gg, InputGroup.en);
        this.fe = ThemeResolver.b(a, InputGroup.ge, InputGroup.el);
        this.fc = ThemeResolver.b(a, InputGroup.gc, InputGroup.ej);
        this.fd = ThemeResolver.b(a, InputGroup.gd, InputGroup.ek);
        this.fh = ThemeResolver.b(a, InputGroup.gh, InputGroup.eo);
        this.q4 = ThemeResolver.e(a, InputGroup.ry, InputGroup.qi);
        this.dg = ThemeResolver.b(a, InputGroup.fv, InputGroup.d2);
        this.dh = ThemeResolver.b(a, InputGroup.fw, InputGroup.d3);
        this.m5 = ThemeResolver.d(a, InputGroup.ne, InputGroup.m8);
        this.tl = ThemeResolver.f(a, InputGroup.tu, InputGroup.to);
        this.pp = ThemeResolver.e(a, InputGroup.rn, InputGroup.p7);
        this.pq = ThemeResolver.e(a, InputGroup.ro, InputGroup.p8);
        this.pr = ThemeResolver.e(a, InputGroup.rp, InputGroup.p9);
        this.dq = ThemeResolver.b(a, InputGroup.f4, InputGroup.eb);
        this.dp = ThemeResolver.b(a, InputGroup.f3, InputGroup.ea);
        this.dl = ThemeResolver.b(a, InputGroup.f0, InputGroup.d7);
        this.pu = ThemeResolver.e(a, InputGroup.rs, InputGroup.qc);
        this.pv = ThemeResolver.e(a, InputGroup.rt, InputGroup.qd);
        this.pt = ThemeResolver.e(a, InputGroup.rr, InputGroup.qb);
        this.ps = ThemeResolver.e(a, InputGroup.rq, InputGroup.qa);
        this.dm = ThemeResolver.b(a, InputGroup.f1, InputGroup.d8);
        this.dk = ThemeResolver.b(a, InputGroup.fz, InputGroup.d6);
        this.di = ThemeResolver.b(a, InputGroup.fx, InputGroup.d4);
        this.dj = ThemeResolver.b(a, InputGroup.fy, InputGroup.d5);
        this.dn = ThemeResolver.b(a, InputGroup.f2, InputGroup.d9);
        this.po = ThemeResolver.e(a, InputGroup.rm, InputGroup.p6);
        this.c5 = ThemeResolver.b(a, InputGroup.fk, InputGroup.dr);
        this.c6 = ThemeResolver.b(a, InputGroup.fl, InputGroup.ds);
        this.m4 = ThemeResolver.d(a, InputGroup.nd, InputGroup.m7);
        this.tk = ThemeResolver.f(a, InputGroup.tt, InputGroup.tn);
        this.ph = ThemeResolver.e(a, InputGroup.rf, InputGroup.pz);
        this.pi = ThemeResolver.e(a, InputGroup.rg, InputGroup.p0);
        this.pj = ThemeResolver.e(a, InputGroup.rh, InputGroup.p1);
        this.de = ThemeResolver.b(a, InputGroup.ft, InputGroup.d0);
        this.dd = ThemeResolver.b(a, InputGroup.fs, InputGroup.dz);
        this.da = ThemeResolver.b(a, InputGroup.fp, InputGroup.dw);
        this.pm = ThemeResolver.e(a, InputGroup.rk, InputGroup.p4);
        this.pn = ThemeResolver.e(a, InputGroup.rl, InputGroup.p5);
        this.pl = ThemeResolver.e(a, InputGroup.rj, InputGroup.p3);
        this.pk = ThemeResolver.e(a, InputGroup.ri, InputGroup.p2);
        this.db = ThemeResolver.b(a, InputGroup.fq, InputGroup.dx);
        this.c9 = ThemeResolver.b(a, InputGroup.fo, InputGroup.dv);
        this.c7 = ThemeResolver.b(a, InputGroup.fm, InputGroup.dt);
        this.c8 = ThemeResolver.b(a, InputGroup.fn, InputGroup.du);
        this.dc = ThemeResolver.b(a, InputGroup.fr, InputGroup.dy);
        this.pg = ThemeResolver.e(a, InputGroup.re, InputGroup.py);
        this.gy = ThemeResolver.b(a, InputGroup.gk, InputGroup.er);
        this.gz = ThemeResolver.b(a, InputGroup.gl, InputGroup.es);
        this.ni = ThemeResolver.d(a, InputGroup.nh, InputGroup.nb);
        this.ty = ThemeResolver.f(a, InputGroup.tx, InputGroup.tr);
        this.sh = ThemeResolver.e(a, InputGroup.r7, InputGroup.qr);
        this.si = ThemeResolver.e(a, InputGroup.r8, InputGroup.qs);
        this.sj = ThemeResolver.e(a, InputGroup.r9, InputGroup.qt);
        this.g7 = ThemeResolver.b(a, InputGroup.gt, InputGroup.e0);
        this.g6 = ThemeResolver.b(a, InputGroup.gs, InputGroup.ez);
        this.g3 = ThemeResolver.b(a, InputGroup.gp, InputGroup.ew);
        this.sm = ThemeResolver.e(a, InputGroup.sc, InputGroup.qw);
        this.sn = ThemeResolver.e(a, InputGroup.sd, InputGroup.qx);
        this.sl = ThemeResolver.e(a, InputGroup.sb, InputGroup.qv);
        this.sk = ThemeResolver.e(a, InputGroup.sa, InputGroup.qu);
        this.g4 = ThemeResolver.b(a, InputGroup.gq, InputGroup.ex);
        this.g2 = ThemeResolver.b(a, InputGroup.go, InputGroup.ev);
        this.g0 = ThemeResolver.b(a, InputGroup.gm, InputGroup.et);
        this.g1 = ThemeResolver.b(a, InputGroup.gn, InputGroup.eu);
        this.g5 = ThemeResolver.b(a, InputGroup.gr, InputGroup.ey);
        this.sg = ThemeResolver.e(a, InputGroup.r6, InputGroup.qq);
    };
    InputGroup.prototype.l6 = function () {
        var _this = this;
        this.l1();
        if (this.ac) {
            this.l3(function (a) { return a.ch(true, !_this.ad); });
            this.l2(function (a) { return a.de(_this.al, !_this.ad); });
        }
        else {
            this.l3(function (a) { return a.ch(false, !_this.ad); });
            this.l2(function (a) { return a.de(_this.al, !_this.ad); });
        }
    };
    InputGroup.prototype.mb = function () {
        this.l1();
        if (this.ai) {
            var a = 1;
            this.l3(function (b) { return b.al = true; });
            this.mf(a);
        }
        else {
            var b = -1;
            this.l3(function (c) { return c.al = false; });
            this.mf(b);
        }
    };
    InputGroup.prototype.ma = function () {
        this.ac = this.t ? this.ah : true;
        this.ai = true;
        if (null != this.gotFocus) {
            this.gotFocus(this, EventArgs.empty);
        }
    };
    InputGroup.prototype.ms = function () {
        if (this.t) {
            this.ac = this.t;
        }
        else if (this.ai) {
            this.ac = true;
        }
        else {
            this.ac = this.af ? true : false;
        }
    };
    InputGroup.prototype.mf = function (a) {
        var _this = this;
        if ((a > 0 && this.q.playbackRate < 0) || (a < 0 && this.q.playbackRate > 0)) {
            this.q.reverse();
            this.q.finished.f(function (b) {
                if (_this.q != null) {
                    _this.q.commitStyles();
                }
                if (_this.ab) {
                    _this.q = null;
                    _this.ab = false;
                }
            });
            this.o.reverse();
            this.o.finished.f(function (b) {
                if (_this.o != null) {
                    _this.o.commitStyles();
                }
                if (_this.s) {
                    _this.o = null;
                    _this.s = false;
                }
            });
            this.p.reverse();
            this.p.finished.f(function (b) {
                if (_this.p != null) {
                    _this.p.commitStyles();
                }
                if (_this.aa) {
                    _this.p = null;
                    _this.aa = false;
                }
            });
        }
        else {
            this.q.play();
            this.q.finished.f(function (b) {
                if (_this.q != null) {
                    _this.q.commitStyles();
                }
                if (_this.ab) {
                    _this.q = null;
                    _this.ab = false;
                }
            });
            this.o.play();
            this.o.finished.f(function (b) {
                if (_this.o != null) {
                    _this.o.commitStyles();
                }
                if (_this.s) {
                    _this.o = null;
                    _this.s = false;
                }
            });
            this.p.play();
            this.p.finished.f(function (b) {
                if (_this.p != null) {
                    _this.p.commitStyles();
                }
                if (_this.aa) {
                    _this.p = null;
                    _this.aa = false;
                }
            });
        }
    };
    Object.defineProperty(InputGroup.prototype, "os", {
        get: function () {
            return this.nm;
        },
        set: function (a) {
            var b = this.nm;
            this.nm = a;
            if (b != this.nm) {
                this.md("ActualBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ot", {
        get: function () {
            return this.nn;
        },
        set: function (a) {
            var b = this.nn;
            this.nn = a;
            if (b != this.nn) {
                this.md("ActualFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ca", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (b != this.am) {
                this.md("ActualBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cb", {
        get: function () {
            return this.an;
        },
        set: function (a) {
            var b = this.an;
            this.an = a;
            if (b != this.an) {
                this.md("ActualFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "mz", {
        get: function () {
            return this.mt;
        },
        set: function (a) {
            var b = this.mt;
            this.mt = a;
            if (b != this.mt) {
                this.md("ActualCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "tf", {
        get: function () {
            return this.s9;
        },
        set: function (a) {
            var b = this.s9;
            this.s9 = a;
            if (b != this.s9) {
                this.md("ActualContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cj", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            if (b != this.av) {
                this.md("ActualUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ci", {
        get: function () {
            return this.au;
        },
        set: function (a) {
            var b = this.au;
            this.au = a;
            if (b != this.au) {
                this.md("ActualUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cf", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            if (b != this.ar) {
                this.md("ActualHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ow", {
        get: function () {
            return this.nq;
        },
        set: function (a) {
            var b = this.nq;
            this.nq = a;
            if (b != this.nq) {
                this.md("ActualUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ox", {
        get: function () {
            return this.nr;
        },
        set: function (a) {
            var b = this.nr;
            this.nr = a;
            if (b != this.nr) {
                this.md("ActualUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ov", {
        get: function () {
            return this.np;
        },
        set: function (a) {
            var b = this.np;
            this.np = a;
            if (b != this.np) {
                this.md("ActualHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ou", {
        get: function () {
            return this.no;
        },
        set: function (a) {
            var b = this.no;
            this.n9 = a;
            if (b != this.no) {
                this.md("ActualFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cg", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            this.as = a;
            if (b != this.as) {
                this.md("ActualUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ce", {
        get: function () {
            return this.aq;
        },
        set: function (a) {
            var b = this.aq;
            this.aq = a;
            if (b != this.aq) {
                this.md("ActualHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cc", {
        get: function () {
            return this.ao;
        },
        set: function (a) {
            var b = this.ao;
            this.ao = a;
            if (b != this.ao) {
                this.md("ActualFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cd", {
        get: function () {
            return this.ap;
        },
        set: function (a) {
            var b = this.ap;
            this.ap = a;
            if (b != this.ap) {
                this.md("ActualFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ch", {
        get: function () {
            return this.at;
        },
        set: function (a) {
            var b = this.at;
            this.at = a;
            if (b != this.at) {
                this.md("ActualUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "or", {
        get: function () {
            return this.nl;
        },
        set: function (a) {
            var b = this.nl;
            this.nl = a;
            if (b != this.nl) {
                this.md("ActualBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cu", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (b != this.a6) {
                this.md("BorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hc", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.md("FocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "oz", {
        get: function () {
            return this.nt;
        },
        set: function (a) {
            var b = this.nt;
            this.nt = a;
            if (b != this.nt) {
                this.md("BorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "m3", {
        get: function () {
            return this.mw;
        },
        set: function (a) {
            var b = this.mw;
            this.mw = a;
            if (b != this.mw) {
                this.md("CornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "tj", {
        get: function () {
            return this.tc;
        },
        set: function (a) {
            var b = this.tc;
            this.tc = a;
            if (b != this.tc) {
                this.md("ContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h4", {
        get: function () {
            return this.b9;
        },
        set: function (a) {
            var b = this.b9;
            this.b9 = a;
            if (b != this.b9) {
                this.md("UnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h3", {
        get: function () {
            return this.b8;
        },
        set: function (a) {
            var b = this.b8;
            this.b8 = a;
            if (b != this.b8) {
                this.md("UnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hg", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (b != this.bl) {
                this.md("HoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s7", {
        get: function () {
            return this.op;
        },
        set: function (a) {
            var b = this.op;
            this.op = a;
            if (b != this.op) {
                this.md("UnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s8", {
        get: function () {
            return this.oq;
        },
        set: function (a) {
            var b = this.oq;
            this.oq = a;
            if (b != this.oq) {
                this.md("UnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ss", {
        get: function () {
            return this.oa;
        },
        set: function (a) {
            var b = this.oa;
            this.oa = a;
            if (b != this.oa) {
                this.md("HoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sr", {
        get: function () {
            return this.n9;
        },
        set: function (a) {
            var b = this.n9;
            this.n9 = a;
            if (b != this.n9) {
                this.md("FocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h1", {
        get: function () {
            return this.b6;
        },
        set: function (a) {
            var b = this.b6;
            this.b6 = a;
            if (b != this.b6) {
                this.md("UnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hf", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.md("HoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hd", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.md("FocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "he", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (b != this.bj) {
                this.md("FocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h2", {
        get: function () {
            return this.b7;
        },
        set: function (a) {
            var b = this.b7;
            this.b7 = a;
            if (b != this.b7) {
                this.md("UnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "oy", {
        get: function () {
            return this.ns;
        },
        set: function (a) {
            var b = this.ns;
            this.ns = a;
            if (b != this.ns) {
                this.md("BackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hh", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (b != this.bm) {
                this.md("LineTypeBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hi", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (b != this.bn) {
                this.md("LineTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sv", {
        get: function () {
            return this.od;
        },
        set: function (a) {
            var b = this.od;
            this.od = a;
            if (b != this.od) {
                this.md("LineTypeFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "su", {
        get: function () {
            return this.oc;
        },
        set: function (a) {
            var b = this.oc;
            this.oc = a;
            if (b != this.oc) {
                this.md("LineTypeBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "nj", {
        get: function () {
            return this.mx;
        },
        set: function (a) {
            var b = this.mx;
            this.mx = a;
            if (b != this.mx) {
                this.md("LineTypeCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "tz", {
        get: function () {
            return this.td;
        },
        set: function (a) {
            var b = this.td;
            this.td = a;
            if (b != this.td) {
                this.md("LineTypeContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hq", {
        get: function () {
            return this.bv;
        },
        set: function (a) {
            var b = this.bv;
            this.bv = a;
            if (b != this.bv) {
                this.md("LineTypeUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hp", {
        get: function () {
            return this.bu;
        },
        set: function (a) {
            var b = this.bu;
            this.bu = a;
            if (b != this.bu) {
                this.md("LineTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hm", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            var b = this.br;
            this.br = a;
            if (b != this.br) {
                this.md("LineTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sy", {
        get: function () {
            return this.og;
        },
        set: function (a) {
            var b = this.og;
            this.og = a;
            if (b != this.og) {
                this.md("LineTypeUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sz", {
        get: function () {
            return this.oh;
        },
        set: function (a) {
            var b = this.oh;
            this.oh = a;
            if (b != this.oh) {
                this.md("LineTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sx", {
        get: function () {
            return this.of;
        },
        set: function (a) {
            var b = this.of;
            this.oa = a;
            if (b != this.of) {
                this.md("LineTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sw", {
        get: function () {
            return this.oe;
        },
        set: function (a) {
            var b = this.oe;
            this.oe = a;
            if (b != this.oe) {
                this.md("LineTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hn", {
        get: function () {
            return this.bs;
        },
        set: function (a) {
            var b = this.bs;
            this.bs = a;
            if (b != this.bs) {
                this.md("LineTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hl", {
        get: function () {
            return this.bq;
        },
        set: function (a) {
            var b = this.bq;
            this.bq = a;
            if (b != this.bq) {
                this.md("LineTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hj", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            if (b != this.bo) {
                this.md("LineTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hk", {
        get: function () {
            return this.bp;
        },
        set: function (a) {
            var b = this.bp;
            this.bp = a;
            if (b != this.bp) {
                this.md("LineTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ho", {
        get: function () {
            return this.bt;
        },
        set: function (a) {
            var b = this.bt;
            this.bt = a;
            if (b != this.bt) {
                this.md("LineTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "st", {
        get: function () {
            return this.ob;
        },
        set: function (a) {
            var b = this.ob;
            this.ob = a;
            if (b != this.ob) {
                this.md("LineTypeBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cv", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (b != this.a7) {
                this.md("BoxTypeBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cw", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (b != this.a8) {
                this.md("BoxTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o9", {
        get: function () {
            return this.n3;
        },
        set: function (a) {
            var b = this.n3;
            this.n3 = a;
            if (b != this.n3) {
                this.md("BoxTypeFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o8", {
        get: function () {
            return this.n2;
        },
        set: function (a) {
            var b = this.n2;
            this.n2 = a;
            if (b != this.n2) {
                this.md("BoxTypeBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "m1", {
        get: function () {
            return this.mv;
        },
        set: function (a) {
            var b = this.mv;
            this.mv = a;
            if (b != this.mv) {
                this.md("BoxTypeCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "th", {
        get: function () {
            return this.tb;
        },
        set: function (a) {
            var b = this.tb;
            this.tb = a;
            if (b != this.tb) {
                this.md("BoxTypeContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "c4", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (b != this.bg) {
                this.md("BoxTypeUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "c3", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (b != this.bf) {
                this.md("BoxTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "c0", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            var b = this.bc;
            this.bc = a;
            if (b != this.bc) {
                this.md("BoxTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "pc", {
        get: function () {
            return this.n6;
        },
        set: function (a) {
            var b = this.n6;
            this.n6 = a;
            if (b != this.n6) {
                this.md("BoxTypeUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "pd", {
        get: function () {
            return this.n7;
        },
        set: function (a) {
            var b = this.n7;
            this.n7 = a;
            if (b != this.n7) {
                this.md("BoxTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "pb", {
        get: function () {
            return this.n5;
        },
        set: function (a) {
            var b = this.n5;
            this.oa = a;
            if (b != this.n5) {
                this.md("BoxTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "pa", {
        get: function () {
            return this.n4;
        },
        set: function (a) {
            var b = this.n4;
            this.n4 = a;
            if (b != this.n4) {
                this.md("BoxTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "c1", {
        get: function () {
            return this.bd;
        },
        set: function (a) {
            var b = this.bd;
            this.bd = a;
            if (b != this.bd) {
                this.md("BoxTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cz", {
        get: function () {
            return this.bb;
        },
        set: function (a) {
            var b = this.bb;
            this.bb = a;
            if (b != this.bb) {
                this.md("BoxTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cx", {
        get: function () {
            return this.a9;
        },
        set: function (a) {
            var b = this.a9;
            this.a9 = a;
            if (b != this.a9) {
                this.md("BoxTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cy", {
        get: function () {
            return this.ba;
        },
        set: function (a) {
            var b = this.ba;
            this.ba = a;
            if (b != this.ba) {
                this.md("BoxTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "c2", {
        get: function () {
            return this.be;
        },
        set: function (a) {
            var b = this.be;
            this.be = a;
            if (b != this.be) {
                this.md("BoxTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o7", {
        get: function () {
            return this.n1;
        },
        set: function (a) {
            var b = this.n1;
            this.n1 = a;
            if (b != this.n1) {
                this.md("BoxTypeBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ck", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (b != this.aw) {
                this.md("BorderTypeBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cl", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            if (b != this.ax) {
                this.md("BorderTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o2", {
        get: function () {
            return this.nw;
        },
        set: function (a) {
            var b = this.nw;
            this.nw = a;
            if (b != this.nw) {
                this.md("BorderTypeFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o1", {
        get: function () {
            return this.nv;
        },
        set: function (a) {
            var b = this.nv;
            this.nv = a;
            if (b != this.nv) {
                this.md("BorderTypeBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "m0", {
        get: function () {
            return this.mu;
        },
        set: function (a) {
            var b = this.mu;
            this.mu = a;
            if (b != this.mu) {
                this.md("BorderTypeCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "tg", {
        get: function () {
            return this.ta;
        },
        set: function (a) {
            var b = this.ta;
            this.ta = a;
            if (b != this.ta) {
                this.md("BorderTypeContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ct", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            if (b != this.a5) {
                this.md("BorderTypeUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cs", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            if (b != this.a4) {
                this.md("BorderTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cp", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            var b = this.a1;
            this.a1 = a;
            if (b != this.a1) {
                this.md("BorderTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o5", {
        get: function () {
            return this.nz;
        },
        set: function (a) {
            var b = this.nz;
            this.nz = a;
            if (b != this.nz) {
                this.md("BorderTypeUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o6", {
        get: function () {
            return this.n0;
        },
        set: function (a) {
            var b = this.n0;
            this.n0 = a;
            if (b != this.n0) {
                this.md("BorderTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o4", {
        get: function () {
            return this.ny;
        },
        set: function (a) {
            var b = this.ny;
            this.oa = a;
            if (b != this.ny) {
                this.md("BorderTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o3", {
        get: function () {
            return this.nx;
        },
        set: function (a) {
            var b = this.nx;
            this.nx = a;
            if (b != this.nx) {
                this.md("BorderTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cq", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (b != this.a2) {
                this.md("BorderTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "co", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            var b = this.a0;
            this.a0 = a;
            if (b != this.a0) {
                this.md("BorderTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cm", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (b != this.ay) {
                this.md("BorderTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cn", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.az = a;
            if (b != this.az) {
                this.md("BorderTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "cr", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            if (b != this.a3) {
                this.md("BorderTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "o0", {
        get: function () {
            return this.nu;
        },
        set: function (a) {
            var b = this.nu;
            this.nu = a;
            if (b != this.nu) {
                this.md("BorderTypeBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hr", {
        get: function () {
            return this.bw;
        },
        set: function (a) {
            var b = this.bw;
            this.bw = a;
            if (b != this.bw) {
                this.md("SearchTypeBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hs", {
        get: function () {
            return this.bx;
        },
        set: function (a) {
            var b = this.bx;
            this.bx = a;
            if (b != this.bx) {
                this.md("SearchTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s2", {
        get: function () {
            return this.ok;
        },
        set: function (a) {
            var b = this.ok;
            this.ok = a;
            if (b != this.ok) {
                this.md("SearchTypeFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s1", {
        get: function () {
            return this.oj;
        },
        set: function (a) {
            var b = this.oj;
            this.oj = a;
            if (b != this.oj) {
                this.md("SearchTypeBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "nk", {
        get: function () {
            return this.my;
        },
        set: function (a) {
            var b = this.my;
            this.my = a;
            if (b != this.my) {
                this.md("SearchTypeCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "t0", {
        get: function () {
            return this.te;
        },
        set: function (a) {
            var b = this.te;
            this.te = a;
            if (b != this.te) {
                this.md("SearchTypeContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h0", {
        get: function () {
            return this.b5;
        },
        set: function (a) {
            var b = this.b5;
            this.b5 = a;
            if (b != this.b5) {
                this.md("SearchTypeUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hz", {
        get: function () {
            return this.b4;
        },
        set: function (a) {
            var b = this.b4;
            this.b4 = a;
            if (b != this.b4) {
                this.md("SearchTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hw", {
        get: function () {
            return this.b1;
        },
        set: function (a) {
            var b = this.b1;
            this.b1 = a;
            if (b != this.b1) {
                this.md("SearchTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s5", {
        get: function () {
            return this.on;
        },
        set: function (a) {
            var b = this.on;
            this.on = a;
            if (b != this.on) {
                this.md("SearchTypeUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s6", {
        get: function () {
            return this.oo;
        },
        set: function (a) {
            var b = this.oo;
            this.oo = a;
            if (b != this.oo) {
                this.md("SearchTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s4", {
        get: function () {
            return this.om;
        },
        set: function (a) {
            var b = this.om;
            this.oa = a;
            if (b != this.om) {
                this.md("SearchTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s3", {
        get: function () {
            return this.ol;
        },
        set: function (a) {
            var b = this.ol;
            this.ol = a;
            if (b != this.ol) {
                this.md("SearchTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hx", {
        get: function () {
            return this.b2;
        },
        set: function (a) {
            var b = this.b2;
            this.b2 = a;
            if (b != this.b2) {
                this.md("SearchTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hv", {
        get: function () {
            return this.b0;
        },
        set: function (a) {
            var b = this.b0;
            this.b0 = a;
            if (b != this.b0) {
                this.md("SearchTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ht", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            var b = this.by;
            this.by = a;
            if (b != this.by) {
                this.md("SearchTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hu", {
        get: function () {
            return this.bz;
        },
        set: function (a) {
            var b = this.bz;
            this.bz = a;
            if (b != this.bz) {
                this.md("SearchTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "hy", {
        get: function () {
            return this.b3;
        },
        set: function (a) {
            var b = this.b3;
            this.b3 = a;
            if (b != this.b3) {
                this.md("SearchTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "s0", {
        get: function () {
            return this.oi;
        },
        set: function (a) {
            var b = this.oi;
            this.oi = a;
            if (b != this.oi) {
                this.md("SearchTypeBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ah", {
        get: function () {
            return this.x;
        },
        set: function (a) {
            var b = this.x;
            this.x = a;
            if (b != this.x) {
                this.md("IsExpanded", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.mj = function () {
        this.x = false;
        this.t = false;
        this.ms();
    };
    Object.defineProperty(InputGroup.prototype, "aj", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.md("IsHovered", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ai", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (b != this.y) {
                this.md("IsFocused", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ac", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            var b = this.r;
            this.r = a;
            if (b != this.r) {
                this.md("ActualIsExpanded", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "sq", {
        get: function () {
            return this.n8;
        },
        set: function (a) {
            var b = this.n8;
            this.n8 = a;
            if (b != this.n8) {
                this.md("FocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "ki", {
        get: function () {
            return this.ib;
        },
        set: function (a) {
            var b = this.ib;
            this.ib = a;
            if (b != this.ib) {
                this.md("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "disabled", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (b != this.w) {
                this.md("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.me = function () {
    };
    InputGroup.prototype.onDetachedFromUI = function () {
        this.view.ai();
    };
    InputGroup.prototype.onAttachedToUI = function () {
        this.view.ag();
    };
    InputGroup.prototype.ak = function () {
        return this.view.g();
    };
    InputGroup.prototype.ia = function () {
        return this.i();
    };
    InputGroup.prototype.j9 = function () {
        var a = this.i();
        return a.y();
    };
    InputGroup.prototype.i = function () {
        var a = new InputGroupVisualModelExport();
        a.f = this.g;
        a.e = this.d;
        a.b = AppearanceHelper.a(this.os);
        a.o = this.ca;
        a.p = this.cb;
        a.z = this.mz;
        a.aa = this.tf;
        a.x = this.cj;
        a.w = this.ci;
        a.t = this.cf;
        a.c = AppearanceHelper.a(this.ow);
        a.d = AppearanceHelper.a(this.ox);
        a.u = this.cg;
        a.s = this.ce;
        a.q = this.cc;
        a.r = this.cd;
        a.v = this.ch;
        a.a = AppearanceHelper.a(this.or);
        a.g = this.ac;
        a.j = this.aj;
        a.i = this.ai;
        a.h = this.disabled;
        a.m = new List$1(PrefixVisualModelExport.$, 0);
        a.l = new List$1(LabelVisualModelExport.$, 0);
        a.k = new List$1(InputVisualModelExport.$, 0);
        a.n = new List$1(SuffixVisualModelExport.$, 0);
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(Prefix.$, this.inputs._inner[b]) !== null) {
                if (this.inputs._inner[b].e == null) {
                    this.inputs._inner[b].e = "Prefix" + a.m.count.toString();
                }
                a.m.add1(this.inputs._inner[b].t());
            }
            else if (typeCast(Label.$, this.inputs._inner[b]) !== null) {
                if (this.inputs._inner[b].e == null) {
                    this.inputs._inner[b].e = "Label" + a.l.count.toString();
                }
                a.l.add1(this.inputs._inner[b].au());
            }
            else if (typeCast(Input.$, this.inputs._inner[b]) !== null) {
                if (this.inputs._inner[b].e == null) {
                    this.inputs._inner[b].e = "Input" + a.k.count.toString();
                }
                a.k.add1(this.inputs._inner[b].ba());
            }
            else if (typeCast(Suffix.$, this.inputs._inner[b]) !== null) {
                if (this.inputs._inner[b].e == null) {
                    this.inputs._inner[b].e = "Suffix" + a.n.count.toString();
                }
                a.n.add1(this.inputs._inner[b].t());
            }
        }
        return a;
    };
    InputGroup.prototype.provideContainer = function (a) {
        this.view.ah(a);
    };
    Object.defineProperty(InputGroup.prototype, "inputs", {
        get: function () {
            return this.l;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "h7", {
        get: function () {
            if (!this.h9.hasValue) {
                var a_1 = 0;
                this.l3(function (b) { return a_1++; });
                this.h9 = toNullable(Number_$type, a_1);
            }
            return this.h9.value;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.prototype.mk = function () {
        this.h9 = toNullable(Number_$type, null);
    };
    Object.defineProperty(InputGroup.prototype, "ae", {
        get: function () {
            return this.h7 > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputGroup.prototype, "al", {
        get: function () {
            return !this.ae || this.ac;
        },
        enumerable: true,
        configurable: true
    });
    InputGroup.$t = markType(InputGroup, 'InputGroup', Base.$, [INotifyPropertyChanged_$type]);
    InputGroup.c = 2;
    InputGroup.fu = 0;
    InputGroup.f5 = 0;
    InputGroup.nf = new CornerRadius(1, 0, 0, 0, 0);
    InputGroup.tv = new Thickness(1, 0, 0, 0, 0);
    InputGroup.rd = BrushUtil.g(138, 0, 0, 0);
    InputGroup.ru = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rv = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gx = 1;
    InputGroup.gw = 2;
    InputGroup.f9 = 2;
    InputGroup.se = BrushUtil.g(138, 0, 0, 0);
    InputGroup.sf = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rx = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rw = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gu = 1;
    InputGroup.f8 = 1;
    InputGroup.f6 = 1;
    InputGroup.f7 = 1;
    InputGroup.gv = 0;
    InputGroup.rc = BrushUtil.g(0, 0, 0, 0);
    InputGroup.ga = 0;
    InputGroup.gb = 0;
    InputGroup.ng = new CornerRadius(1, 0, 0, 0, 0);
    InputGroup.tw = new Thickness(1, 0, 0, 0, 0);
    InputGroup.rz = BrushUtil.g(138, 0, 0, 0);
    InputGroup.r0 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.r1 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gj = 1;
    InputGroup.gi = 2;
    InputGroup.gf = 2;
    InputGroup.r4 = BrushUtil.g(138, 0, 0, 0);
    InputGroup.r5 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.r3 = BrushUtil.g(138, 0, 0, 0);
    InputGroup.r2 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gg = 1;
    InputGroup.ge = 1;
    InputGroup.gc = 1;
    InputGroup.gd = 1;
    InputGroup.gh = 0;
    InputGroup.ry = BrushUtil.g(0, 0, 0, 0);
    InputGroup.fv = 0;
    InputGroup.fw = 0;
    InputGroup.ne = new CornerRadius(1, 4, 4, 0, 0);
    InputGroup.tu = new Thickness(1, 16, 0, 16, 0);
    InputGroup.rn = BrushUtil.g(138, 0, 0, 0);
    InputGroup.ro = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rp = BrushUtil.g(255, 0, 153, 155);
    InputGroup.f4 = 1;
    InputGroup.f3 = 2;
    InputGroup.f0 = 2;
    InputGroup.rs = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rt = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rr = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rq = BrushUtil.g(255, 0, 153, 155);
    InputGroup.f1 = 1;
    InputGroup.fz = 1;
    InputGroup.fx = 1;
    InputGroup.fy = 1;
    InputGroup.f2 = 0;
    InputGroup.rm = BrushUtil.g(20, 0, 0, 0);
    InputGroup.fk = 1;
    InputGroup.fl = 2;
    InputGroup.nd = new CornerRadius(1, 4, 4, 4, 4);
    InputGroup.tt = new Thickness(1, 16, 0, 16, 0);
    InputGroup.rf = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rg = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rh = BrushUtil.g(255, 0, 153, 155);
    InputGroup.ft = 1;
    InputGroup.fs = 2;
    InputGroup.fp = 2;
    InputGroup.rk = BrushUtil.g(138, 0, 0, 0);
    InputGroup.rl = BrushUtil.g(255, 0, 153, 155);
    InputGroup.rj = BrushUtil.g(138, 0, 0, 0);
    InputGroup.ri = BrushUtil.g(255, 0, 153, 155);
    InputGroup.fq = 0;
    InputGroup.fo = 0;
    InputGroup.fm = 0;
    InputGroup.fn = 0;
    InputGroup.fr = 0;
    InputGroup.re = BrushUtil.g(0, 0, 0, 0);
    InputGroup.gk = 1;
    InputGroup.gl = 2;
    InputGroup.nh = new CornerRadius(1, 4, 4, 4, 4);
    InputGroup.tx = new Thickness(1, 16, 0, 16, 0);
    InputGroup.r7 = BrushUtil.g(138, 0, 0, 0);
    InputGroup.r8 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.r9 = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gt = 1;
    InputGroup.gs = 2;
    InputGroup.gp = 2;
    InputGroup.sc = BrushUtil.g(138, 0, 0, 0);
    InputGroup.sd = BrushUtil.g(255, 0, 153, 155);
    InputGroup.sb = BrushUtil.g(138, 0, 0, 0);
    InputGroup.sa = BrushUtil.g(255, 0, 153, 155);
    InputGroup.gq = 0;
    InputGroup.go = 0;
    InputGroup.gm = 0;
    InputGroup.gn = 0;
    InputGroup.gr = 0;
    InputGroup.r6 = BrushUtil.g(0, 0, 0, 0);
    InputGroup.d1 = 0;
    InputGroup.ec = 0;
    InputGroup.m9 = new CornerRadius(1, 0, 0, 0, 0);
    InputGroup.tp = new Thickness(1, 0, 0, 0, 0);
    InputGroup.px = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qe = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qf = BrushUtil.g(255, 33, 150, 243);
    InputGroup.e4 = 1;
    InputGroup.e3 = 2;
    InputGroup.eg = 2;
    InputGroup.qy = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qz = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qh = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qg = BrushUtil.g(255, 33, 150, 243);
    InputGroup.e1 = 1;
    InputGroup.ef = 1;
    InputGroup.ed = 1;
    InputGroup.ee = 1;
    InputGroup.e2 = 0;
    InputGroup.pw = BrushUtil.g(0, 0, 0, 0);
    InputGroup.eh = 0;
    InputGroup.ei = 0;
    InputGroup.na = new CornerRadius(1, 0, 0, 0, 0);
    InputGroup.tq = new Thickness(1, 0, 0, 0, 0);
    InputGroup.qj = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qk = BrushUtil.g(255, 33, 150, 243);
    InputGroup.ql = BrushUtil.g(255, 33, 150, 243);
    InputGroup.eq = 1;
    InputGroup.ep = 2;
    InputGroup.em = 2;
    InputGroup.qo = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qp = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qn = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qm = BrushUtil.g(255, 33, 150, 243);
    InputGroup.en = 1;
    InputGroup.el = 1;
    InputGroup.ej = 1;
    InputGroup.ek = 1;
    InputGroup.eo = 0;
    InputGroup.qi = BrushUtil.g(0, 0, 0, 0);
    InputGroup.d2 = 0;
    InputGroup.d3 = 0;
    InputGroup.m8 = new CornerRadius(1, 4, 4, 0, 0);
    InputGroup.to = new Thickness(1, 16, 0, 16, 0);
    InputGroup.p7 = BrushUtil.g(255, 186, 191, 199);
    InputGroup.p8 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.p9 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.eb = 1;
    InputGroup.ea = 2;
    InputGroup.d7 = 2;
    InputGroup.qc = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qd = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qb = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qa = BrushUtil.g(255, 33, 150, 243);
    InputGroup.d8 = 1;
    InputGroup.d6 = 1;
    InputGroup.d4 = 1;
    InputGroup.d5 = 1;
    InputGroup.d9 = 0;
    InputGroup.p6 = BrushUtil.g(20, 0, 0, 0);
    InputGroup.dr = 1;
    InputGroup.ds = 2;
    InputGroup.m7 = new CornerRadius(1, 4, 4, 4, 4);
    InputGroup.tn = new Thickness(1, 16, 0, 16, 0);
    InputGroup.pz = BrushUtil.g(255, 186, 191, 199);
    InputGroup.p0 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.p1 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.d0 = 1;
    InputGroup.dz = 2;
    InputGroup.dw = 2;
    InputGroup.p4 = BrushUtil.g(255, 186, 191, 199);
    InputGroup.p5 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.p3 = BrushUtil.g(255, 186, 191, 199);
    InputGroup.p2 = BrushUtil.g(255, 33, 150, 243);
    InputGroup.dx = 0;
    InputGroup.dv = 0;
    InputGroup.dt = 0;
    InputGroup.du = 0;
    InputGroup.dy = 0;
    InputGroup.py = BrushUtil.g(0, 0, 0, 0);
    InputGroup.er = 1;
    InputGroup.es = 2;
    InputGroup.nb = new CornerRadius(1, 4, 4, 4, 4);
    InputGroup.tr = new Thickness(1, 16, 0, 16, 0);
    InputGroup.qr = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qs = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qt = BrushUtil.g(255, 33, 150, 243);
    InputGroup.e0 = 1;
    InputGroup.ez = 2;
    InputGroup.ew = 2;
    InputGroup.qw = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qx = BrushUtil.g(255, 33, 150, 243);
    InputGroup.qv = BrushUtil.g(255, 186, 191, 199);
    InputGroup.qu = BrushUtil.g(255, 33, 150, 243);
    InputGroup.ex = 0;
    InputGroup.ev = 0;
    InputGroup.et = 0;
    InputGroup.eu = 0;
    InputGroup.ey = 0;
    InputGroup.qq = BrushUtil.g(0, 0, 0, 0);
    InputGroup.h8 = 0;
    return InputGroup;
}(Base));
export { InputGroup };
/**
 * @hidden
 */
var InputGroupInputCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputGroupInputCollection, _super);
    function InputGroupInputCollection() {
        var _this = _super.call(this, InputGroupItem.$, 0) || this;
        _this.collectionResetting = null;
        return _this;
    }
    InputGroupInputCollection.prototype.p = function () {
        if (this.collectionResetting != null) {
            this.collectionResetting(this, null);
        }
        _super.prototype.p.call(this);
    };
    InputGroupInputCollection.$t = markType(InputGroupInputCollection, 'InputGroupInputCollection', ObservableCollection$1.$.specialize(InputGroupItem.$));
    return InputGroupInputCollection;
}(ObservableCollection$1));
export { InputGroupInputCollection };
/**
 * @hidden
 */
var Label = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        var _this = _super.call(this) || this;
        _this.j = 0;
        _this._view = null;
        _this.aa = null;
        _this.z = null;
        _this.n = 0;
        _this.m = 1;
        _this.co = ThemeResolver.e(Label.k, Label.c7, Label.c0);
        _this.cl = ThemeResolver.e(Label.k, Label.c4, Label.cx);
        _this.cm = ThemeResolver.e(Label.k, Label.c5, Label.cy);
        _this.cn = ThemeResolver.e(Label.k, Label.c6, Label.cz);
        _this.u = null;
        _this.cs = Label.c8;
        _this.cp = Label.c1;
        _this.cq = Label.c2;
        _this.r = 0;
        _this.af = false;
        _this.ad = false;
        _this.v = null;
        _this.cr = null;
        _this.a1 = "ig-label-" + Label.at++;
        _this.ax = "inline-block";
        _this.ay = "inline-block";
        _this.az = null;
        _this.av = "center";
        _this.ar = 0;
        _this.ab = false;
        _this.a0 = null;
        _this.aw = null;
        _this.a2 = null;
        _this.ae = false;
        _this.ai = false;
        _this.ac = false;
        _this.ah = false;
        _this.ag = false;
        _this.ap = false;
        var a = new LabelView();
        a.c = _this;
        _this.view = a;
        _this.view.aa();
        return _this;
    }
    Object.defineProperty(Label.prototype, "l", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(Label.prototype, "i", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.b5 = function () {
        var _this = this;
        this.view.s();
        var a = false;
        if (this.aa == null) {
            var b = new TransformGroup();
            b.j.add(((function () {
                var $ret = new TranslateTransform();
                $ret.k = _this.view.j();
                return $ret;
            })()));
            b.j.add(((function () {
                var $ret = new ScaleTransform();
                $ret.l = 1;
                $ret.m = 1;
                return $ret;
            })()));
            var c_1 = -(this.view.i() * 1.3);
            if (this.o == 2) {
                c_1 = -(this.view.i() * 1.05);
            }
            if (this.o == 3) {
                c_1 = -(this.view.i() * 1.01);
            }
            var d = new TransformGroup();
            d.j.add(((function () {
                var $ret = new TranslateTransform();
                $ret.k = _this.s == 2 ? c_1 : -(_this.view.i() * 0.65);
                return $ret;
            })()));
            d.j.add(((function () {
                var $ret = new ScaleTransform();
                $ret.l = 0.75;
                $ret.m = 0.75;
                return $ret;
            })()));
            this.aa = KeyFrameAnimationFactory.f.c(this.view.b(this.i).m(new AnimationKeyFrameProperty(14, b), new AnimationKeyFrameProperty(2, BrushUtil.g(0, 255, 255, 255))).m(new AnimationKeyFrameProperty(14, d), new AnimationKeyFrameProperty(2, BrushUtil.g(this.s == 2 ? 255 : 0, 255, 255, 255))));
        }
        if (this.z == null) {
            this.z = KeyFrameAnimationFactory.f.c(this.view.a(this.i).m(new AnimationKeyFrameProperty(7, this.cw)).m(new AnimationKeyFrameProperty(7, this.ct)));
        }
    };
    Label.prototype.cf = function (a, b) {
        var _this = this;
        if ((b > 0 && a.playbackRate < 0) || (b < 0 && a.playbackRate > 0)) {
            a.reverse();
            if (this.ap) {
                a.finish();
                this.b6(a);
                return;
            }
            a.finished.f(function (c) { return _this.b6(a); });
        }
        else {
            a.play();
            if (this.ap) {
                a.finish();
                this.b6(a);
                return;
            }
            a.finished.f(function (c) { return _this.b6(a); });
        }
    };
    Label.prototype.b6 = function (a) {
        a.commitStyles();
        if (a == this.aa && this.ah) {
            this.aa = null;
        }
        if (a == this.z && this.ag) {
            this.z = null;
        }
    };
    Label.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "BaseTheme":
                this.ci(this.l);
                this.ck();
                break;
            case "TextColor":
            case "HoverTextColor":
            case "TextStyle":
            case "HighlightTextColor":
            case "HoverHighlightTextColor":
                this.ck();
                break;
            case "ActualTextColor":
            case "ActualHoverTextColor":
            case "ActualTextStyle":
            case "ActualHighlightTextColor":
            case "ActualHoverHighlightTextColor":
                if (this.aa != null) {
                    if (this.aa.playState == 3) {
                        this.aa = null;
                    }
                    else {
                        this.ah = true;
                    }
                }
                if (this.z != null) {
                    if (this.z.playState == 3) {
                        this.z = null;
                    }
                    else {
                        this.ag = true;
                    }
                }
                this.cj();
                break;
            case "Text":
                this.view.ad();
                break;
            case "Density":
                this.o = this.p == 0 ? 1 : this.p;
                break;
            case "ActualDensity":
                this.view.af();
                this.view.ae();
                break;
            case "InputGroup":
                this.view.ae();
                break;
            case "IsHighlighted":
                this.b9();
                break;
            case "IsShifted":
                this.ca();
                break;
            case "ShiftType":
                if (this.aa != null) {
                    if (this.aa.playState == 3) {
                        this.aa = null;
                    }
                    else {
                        this.ah = true;
                    }
                }
                this.cd();
                break;
            case "Display":
                this.view.x();
                break;
            case "FlexDirection":
                this.view.y();
                break;
            case "FlexGrow":
                this.view.z();
                break;
            case "AlignItems":
                this.view.t();
                break;
        }
    };
    Label.prototype.cd = function () {
        this.view.ae();
    };
    Label.prototype.ca = function () {
        this.b5();
        var a = 1;
        var b = this.an;
        if (!b) {
            a = -1;
        }
        this.cf(this.aa, a);
    };
    Label.prototype.b9 = function () {
        this.b5();
        var a = 1;
        var b = this.al;
        if (!b) {
            a = -1;
        }
        this.cf(this.z, a);
    };
    Label.prototype.ck = function () {
        this.cw = this.dc != null ? this.dc : Label.c8;
        this.cv = this.db != null ? this.db : Label.c8;
        this.ct = this.c9 != null ? this.c9 : Label.c1;
        this.w = this.y != null ? this.y : Label.x;
    };
    Label.prototype.cj = function () {
        if (this.w != null) {
            this.view.ah(this.w);
        }
        this.view.ac(this.cw);
    };
    Label.prototype.ci = function (a) {
        Label.c8 = ThemeResolver.e(a, Label.c7, Label.c0);
        Label.c1 = ThemeResolver.e(a, Label.c4, Label.cx);
        Label.c3 = ThemeResolver.e(a, Label.c6, Label.cz);
        Label.c2 = ThemeResolver.e(a, Label.c5, Label.cy);
    };
    Object.defineProperty(Label.prototype, "p", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.g("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "o", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "cw", {
        get: function () {
            return this.co;
        },
        set: function (a) {
            var b = this.co;
            this.co = a;
            if (b != this.co) {
                this.g("ActualTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "ct", {
        get: function () {
            return this.cl;
        },
        set: function (a) {
            var b = this.cl;
            this.cl = a;
            if (b != this.cl) {
                this.g("ActualHighlightTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "cu", {
        get: function () {
            return this.cm;
        },
        set: function (a) {
            var b = this.cm;
            this.cm = a;
            if (b != this.cm) {
                this.g("ActualHoverHighlightTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "cv", {
        get: function () {
            return this.cn;
        },
        set: function (a) {
            var b = this.cn;
            this.cn = a;
            if (b != this.cn) {
                this.g("ActualHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "w", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (b != this.u) {
                this.g("ActualTextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "dc", {
        get: function () {
            return this.cs;
        },
        set: function (a) {
            var b = this.cs;
            this.cs = a;
            if (b != this.cs) {
                this.g("TextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "c9", {
        get: function () {
            return this.cp;
        },
        set: function (a) {
            var b = this.cp;
            this.cp = a;
            if (b != this.cp) {
                this.g("HighlightTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "da", {
        get: function () {
            return this.cq;
        },
        set: function (a) {
            var b = this.cq;
            this.cq = a;
            if (b != this.cq) {
                this.g("HoverHighlightTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "s", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            var b = this.r;
            this.r = a;
            if (b != this.r) {
                this.g("ShiftType", enumGetBox(LabelShiftType_$type, b), enumGetBox(LabelShiftType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "an", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            var b = this.af;
            this.af = a;
            if (b != this.af) {
                this.g("IsShifted", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.ch = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        var c = this.ap;
        if (!b) {
            this.ap = true;
        }
        try {
            this.an = a;
        }
        finally {
            if (!b) {
                this.ap = c;
            }
        }
    };
    Object.defineProperty(Label.prototype, "al", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            var b = this.ad;
            this.ad = a;
            if (b != this.ad) {
                this.g("IsHighlighted", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.cb = function () {
        this.am = true;
    };
    Label.prototype.cc = function () {
        this.am = false;
    };
    Object.defineProperty(Label.prototype, "y", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.g("TextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "db", {
        get: function () {
            return this.cr;
        },
        set: function (a) {
            var b = this.cr;
            this.cr = a;
            if (b != this.cr) {
                this.g("HoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "br", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            var b = this.a1;
            this.a1 = a;
            if (b != this.a1) {
                this.g("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bf", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            if (b != this.ax) {
                this.g("Display", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bi", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (b != this.ay) {
                this.g("FlexDirection", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bk", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.az = a;
            if (b != this.az) {
                this.g("FlexGrow", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "a9", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            if (b != this.av) {
                this.g("AlignItems", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "aj", {
        get: function () {
            return this.ab;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "as", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            this.ab = true;
            if (b != this.ar) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bm", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            var b = this.a0;
            this.a0 = a;
            if (b != this.a0) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "bb", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (b != this.aw) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "text", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (b != this.a2) {
                this.g("Text", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "am", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            var b = this.ae;
            this.ae = a;
            if (b != this.ae) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "aq", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (b != this.ai) {
                this.g("Value", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Label.prototype, "disabled", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (b != this.ac) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Label.prototype.ce = function () {
        this.view.ad();
    };
    Label.prototype.onDetachedFromUI = function () {
        this.view.w();
    };
    Label.prototype.onAttachedToUI = function () {
        this.view.u();
    };
    Label.prototype.ao = function () {
        return this.view.f();
    };
    Label.prototype.au = function () {
        return this.q();
    };
    Label.prototype.bh = function () {
        var a = this.q();
        return a.q();
    };
    Label.prototype.q = function () {
        var a = new LabelVisualModelExport();
        var b = this.view.n;
        a.b = this.l;
        a.d = this.p;
        a.c = this.o;
        a.a = AppearanceHelper.a(NativeUI.af(b));
        a.e = this.s;
        a.i = this.an;
        a.g = this.al;
        a.m = this.bf;
        a.n = this.bi;
        a.o = this.bk;
        a.l = this.a9;
        a.r = this.text;
        a.h = this.am;
        a.j = this.aq;
        a.f = this.disabled;
        a.p = this.e;
        if (this.w != null) {
            var c = this.w;
            if (this.view != null && c.n == null) {
                var d = this.view.k;
                var e = FontUtil.getFontInfoFromString(d, c.fontString);
                c.n = e.n;
                c.d = e.d;
                c.o = e.o;
                c.q = e.q;
                c.r = e.r;
                c.s = e.s;
            }
            if (c.n != null) {
                a.s = c.n;
            }
            if (!isNaN_(c.d)) {
                a.k = c.d;
            }
            if (c.s != null) {
                a.w = c.s;
            }
            if (c.q != null) {
                a.u = c.q;
            }
            if (c.o != null) {
                a.t = c.q;
            }
        }
        return a;
    };
    Label.prototype.provideContainer = function (a) {
        this.view.v(a);
    };
    Label.$t = markType(Label, 'Label', InputGroupItem.$);
    Label.c7 = BrushUtil.g(221, 0, 0, 0);
    Label.c4 = BrushUtil.g(255, 0, 153, 155);
    Label.c6 = BrushUtil.g(221, 0, 0, 0);
    Label.c5 = BrushUtil.g(255, 0, 153, 155);
    Label.c0 = BrushUtil.g(255, 24, 29, 31);
    Label.cx = BrushUtil.g(255, 33, 150, 243);
    Label.cz = BrushUtil.g(255, 24, 29, 31);
    Label.cy = BrushUtil.g(255, 33, 150, 243);
    Label.k = 2;
    Label.c8 = ThemeResolver.e(Label.k, Label.c7, Label.c0);
    Label.c1 = ThemeResolver.e(Label.k, Label.c4, Label.cx);
    Label.c3 = ThemeResolver.e(Label.k, Label.c6, Label.cz);
    Label.c2 = ThemeResolver.e(Label.k, Label.c5, Label.cy);
    Label.x = null;
    Label.at = 0;
    return Label;
}(InputGroupItem));
export { Label };
/**
 * @hidden
 */
var Input = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input() {
        var _this = _super.call(this) || this;
        _this.x = null;
        _this.a1 = 0;
        _this.a2 = 0;
        _this.t = 0;
        _this.bj = "";
        _this.bd = "";
        _this.ae = false;
        _this.be = null;
        _this.af = false;
        _this.am = false;
        _this._view = null;
        _this.q = 0;
        _this.k = 1;
        _this.j = 1;
        _this.bi = null;
        _this.bl = "_";
        _this.ah = false;
        _this.dm = Input.dt;
        _this.dl = Input.ds;
        _this.y = null;
        _this.dp = Input.dt;
        _this.keyDown = null;
        _this.keyUp = null;
        _this.keyPress = null;
        _this.gotFocus = null;
        _this.lostFocus = null;
        _this.mouseDown = null;
        _this.mouseUp = null;
        _this.z = null;
        _this.bh = "text";
        _this.bk = "text";
        _this.dn = null;
        _this.bg = "ig-input-" + Input.a9++;
        _this.a3 = 0;
        _this.ag = false;
        _this.bf = null;
        _this.bc = null;
        _this.ak = false;
        _this.bb = null;
        _this.bm = null;
        _this.aj = false;
        _this.ai = false;
        _this.change = null;
        _this.changing = null;
        _this.compositionStart = null;
        _this.compositionEnd = null;
        _this.al = true;
        _this.ad = null;
        _this.au = false;
        _this.x = new MaskParsingService();
        var a = new InputView();
        a.b = _this;
        _this.view = a;
        _this.view.ao();
        Input.ab = new FontInfo();
        Input.ab.n = "'Segoe UI', Verdana";
        return _this;
    }
    Object.defineProperty(Input.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(Input.prototype, "r", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            if (b != this.q) {
                this.g("ShiftType", enumGetBox(InputShiftType_$type, b), enumGetBox(InputShiftType_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "m", {
        get: function () {
            return this.k;
        },
        set: function (a) {
            var b = this.k;
            this.k = a;
            if (b != this.k) {
                this.g("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "l", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "b6", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.g("Mask", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "ca", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (b != this.bl) {
                this.g("PromptChar", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "ap", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            var b = this.ah;
            this.ah = a;
            if (b != this.ah) {
                this.g("IncludeLiterals", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "TextColor":
            case "HoverTextColor":
            case "TextStyle":
                this.dj();
                break;
            case "ActualTextColor":
            case "ActualHoverTextColor":
            case "ActualTextStyle":
                this.di();
                break;
            case "Value":
                if (!this.ai) {
                    this.view.at(this.cg);
                    if (this.b != null) {
                        this.b.ms();
                    }
                    if (this.b6 != null && !this.am) {
                        this.dk(this.cg);
                    }
                }
                break;
            case "Density":
                this.l = this.m == 0 ? 1 : this.m;
                break;
            case "ActualDensity":
                this.view.az();
                this.view.ay();
                break;
            case "InputGroup":
                this.cx();
                break;
            case "ShiftType":
                this.c8();
                break;
            case "InputType":
                this.c9();
                break;
            case "Placeholder":
                this.c7();
                break;
            case "Mask":
                this.b8 = this.b6;
                break;
            case "PromptChar": break;
            case "IncludeLiterals": break;
            case "IsShown":
                this.cy();
                break;
            case "IsDisabled":
                this.view.au(this.aj);
                break;
        }
    };
    Input.prototype.c7 = function () {
        this.view.aq();
    };
    Input.prototype.c9 = function () {
        this.view.as();
    };
    Input.prototype.c8 = function () {
        this.view.ay();
    };
    Input.prototype.cx = function () {
        this.view.ay();
    };
    Input.prototype.dj = function () {
        this.dr = this.dv != null ? this.dv : Input.dt;
        this.dq = this.du != null ? this.du : Input.dt;
        this.aa = this.ac != null ? this.ac : Input.ab;
    };
    Input.prototype.di = function () {
        if (this.aa != null) {
            this.view.a1(this.aa);
        }
        NativeUI.n(this.view.o, this.dr);
    };
    Object.defineProperty(Input.prototype, "dr", {
        get: function () {
            return this.dm;
        },
        set: function (a) {
            var b = this.dm;
            this.dm = a;
            if (b != this.dm) {
                this.g("ActualTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "dq", {
        get: function () {
            return this.dl;
        },
        set: function (a) {
            var b = this.dl;
            this.dl = a;
            if (b != this.dl) {
                this.g("ActualHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "aa", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (b != this.y) {
                this.g("ActualTextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "dv", {
        get: function () {
            return this.dp;
        },
        set: function (a) {
            var b = this.dp;
            this.dp = a;
            if (b != this.dp) {
                this.g("TextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.co = function () {
        if (this.b6 != null) {
            this.dg(this.cg);
        }
        if (null != this.lostFocus) {
            this.lostFocus(this, EventArgs.empty);
        }
    };
    Input.prototype.cw = function () {
        if (this.b6 != null) {
            this.dh(this.cg);
        }
        if (null != this.gotFocus) {
            this.gotFocus(this, EventArgs.empty);
        }
    };
    Input.prototype.cz = function (a) {
        if (this.b6 != null) {
            var b = a.keyCode;
            if ((b == 17 && b == 90) || (b == 17 && b == 89)) {
                a.preventDefault();
            }
            this.t = b;
            this.a2 = this.a5();
            this.a1 = this.a4();
        }
        if (null != this.keyDown) {
            this.keyDown(this, a);
        }
    };
    Input.prototype.c1 = function (a) {
        if (null != this.keyUp) {
            this.keyUp(this, a);
        }
    };
    Input.prototype.c0 = function (a) {
        if (null != this.keyPress) {
            this.keyPress(this, a);
        }
    };
    Input.prototype.c2 = function (a) {
        if (null != this.mouseDown) {
            this.mouseDown(this, a);
        }
    };
    Input.prototype.c5 = function (a) {
        if (null != this.mouseUp) {
            this.mouseUp(this, a);
        }
    };
    Input.prototype.c6 = function () {
        if (this.b6 != null) {
            this.bj = this.cg;
            this.a2 = this.a5();
        }
    };
    Input.prototype.cu = function () {
        if (this.b6 != null) {
            if (!this.ae) {
                this.dh(this.bd);
            }
        }
    };
    Input.prototype.cv = function () {
        if (this.b6 != null) {
            if (!this.ae) {
                this.dg(this.cg);
            }
        }
    };
    Input.prototype.cp = function () {
        var _this = this;
        this.ai = true;
        this.cg = this.view.q();
        if (this.change != null) {
            this.change(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.cg;
                $ret.isCompositionInProgress = _this.view.e;
                return $ret;
            })()));
        }
        this.ai = false;
    };
    Input.prototype.cq = function () {
        var _this = this;
        this.ai = true;
        this.cg = this.view.q();
        this.ai = false;
        if (this.b6 != null) {
            this.am = true;
            if (this.af) {
                this.a2 = this.a5();
            }
            if (this.cg.length < this.bj.length && this.t == 229) {
                this.t = 8;
            }
            var a = this.a5();
            var b = this.a4();
            var c = "";
            switch (this.t) {
                case 46:
                    this.a1 = this.a2 == this.a1 ? ++this.a1 : this.a1;
                    break;
                case 8:
                    this.a2 = this.a5();
                    break;
                default:
                    c = this.cg.substr(this.a2, this.a4() - this.a2);
                    break;
            }
            var d = new MaskOptions();
            d.a = this.b6;
            d.b = this.ca;
            var e = this.x.a(this.bj, c, d, this.a2, this.a1);
            this.cg = e.b;
            if (this.t == 8) {
                e.a = this.a2;
            }
            this.df(e.a, e.a);
            var f = this.x.i(this.cg, d);
            this.bd = this.ap ? this.cg : f;
            this.ci();
            this.am = false;
        }
        this.ai = true;
        if (this.changing != null) {
            this.changing(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.cg;
                $ret.isCompositionInProgress = _this.view.e;
                return $ret;
            })()));
        }
        this.ai = false;
    };
    Input.prototype.cs = function () {
        if (this.compositionStart != null) {
            this.compositionStart(this, new EventArgs());
        }
    };
    Input.prototype.cr = function () {
        if (this.compositionEnd != null) {
            this.compositionEnd(this, new EventArgs());
        }
    };
    Input.prototype.c3 = function () {
        this.ar = true;
    };
    Input.prototype.c4 = function () {
        this.ar = false;
    };
    Object.defineProperty(Input.prototype, "ac", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.g("TextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "b1", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.g("InputType", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "b8", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.g("Placeholder", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "du", {
        get: function () {
            return this.dn;
        },
        set: function (a) {
            var b = this.dn;
            this.dn = a;
            if (b != this.dn) {
                this.g("HoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "by", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (b != this.bg) {
                this.g("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "an", {
        get: function () {
            return this.ag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "a8", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            this.ag = true;
            if (b != this.a3) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "bv", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (b != this.bf) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "br", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            var b = this.bc;
            this.bc = a;
            if (b != this.bc) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "ar", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            if (b != this.ak) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "cg", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (b != this.bm) {
                this.g("Value", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "ao", {
        get: function () {
            return !stringIsNullOrEmpty(this.cg);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "disabled", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            var b = this.aj;
            this.aj = a;
            if (b != this.aj) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.da = function () {
    };
    Input.prototype.onDetachedFromUI = function () {
        this.view.am();
    };
    Input.prototype.onAttachedToUI = function () {
        this.view.aj();
    };
    Input.prototype.at = function () {
        return this.view.f();
    };
    Input.prototype.ba = function () {
        return this.n();
    };
    Input.prototype.bu = function () {
        var a = this.n();
        return a.n();
    };
    Input.prototype.n = function () {
        var a = new InputVisualModelExport();
        var b = this.view.o;
        a.h = this.view.j.rootWrapper.getNativeElement().offsetTop;
        a.f = this.view.j.rootWrapper.getNativeElement().offsetLeft;
        a.c = this.r;
        a.b = this.l;
        a.j = this.b6;
        a.m = this.ca;
        a.d = this.ap;
        a.a = AppearanceHelper.a(NativeUI.af(b));
        a.i = this.b1;
        a.l = this.b8;
        a.e = this.ar;
        a.t = this.cg;
        a.k = this.e;
        if (this.aa != null) {
            var c = this.aa;
            if (this.view != null && c.n == null) {
                var d = this.view.j;
                var e = FontUtil.getFontInfoFromString(d, c.fontString);
                c.n = e.n;
                c.d = e.d;
                c.o = e.o;
                c.q = e.q;
                c.r = e.r;
                c.s = e.s;
            }
            if (c.n != null) {
                a.o = c.n;
            }
            if (!isNaN_(c.d)) {
                a.g = c.d;
            }
            if (c.s != null) {
                a.s = c.s;
            }
            if (c.q != null) {
                a.q = c.q;
            }
            if (c.o != null) {
                a.p = c.q;
            }
        }
        return a;
    };
    Input.prototype.df = function (a, b) {
        this.view.aw(a, b);
    };
    Input.prototype.provideContainer = function (a) {
        this.view.al(a);
    };
    Input.prototype.cj = function () {
        this.co();
        this.view.ak();
    };
    Input.prototype.focus = function (a) {
        if (a === void 0) {
            a = false;
        }
        this.cw();
        this.view.an(a);
    };
    Input.prototype.dd = function () {
        this.view.ar();
    };
    Input.prototype.dh = function (a) {
        this.am = true;
        var b = new MaskOptions();
        b.a = this.b6;
        b.b = this.ca;
        this.cg = this.x.h(this.cg, b);
        this.bj = this.cg;
        this.am = false;
    };
    Input.prototype.dg = function (a) {
        this.am = true;
        var b = new MaskOptions();
        b.a = this.b6;
        b.b = this.ca;
        if (a == this.x.h(null, b)) {
            this.cg = "";
        }
        this.am = false;
    };
    Input.prototype.dk = function (a) {
        var _this = this;
        var b = new MaskOptions();
        b.a = this.b6;
        b.b = this.ca;
        if (this.ca != null && this.ca.length > 1) {
            b.b = this.ca.substr(0, 1);
        }
        this.cg = a != null ? this.x.h(a, b) : "";
        this.bd = this.ap ? this.cg : a;
        if (this.changing != null) {
            this.changing(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.cg;
                $ret.isCompositionInProgress = _this.view.e;
                return $ret;
            })()));
        }
    };
    Input.prototype.ci = function () {
        this.bj = this.cg;
        this.af = false;
        this.a2 = 0;
        this.a1 = 0;
        this.t = 0;
    };
    Input.prototype.a5 = function () {
        var a = this.view.n();
        var b = this.view.m();
        return a == b && this.af ? b - this.be.length : a;
    };
    Input.prototype.a4 = function () {
        return this.view.m();
    };
    Object.defineProperty(Input.prototype, "selectionStart", {
        get: function () {
            return this.a5();
        },
        set: function (a) {
            this.view.ax(a);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "selectionEnd", {
        get: function () {
            return this.a4();
        },
        set: function (a) {
            this.view.av(a);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "as", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (b != this.al) {
                this.g("IsShown", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.de = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        var c = this.au;
        if (!b) {
            this.au = true;
        }
        try {
            this.as = a;
        }
        finally {
            if (!b) {
                this.au = c;
            }
        }
    };
    Input.prototype.cy = function () {
        this.cl();
        this.db(this.ad, this.as);
    };
    Input.prototype.cl = function () {
        this.view.ai();
        if (this.ad == null) {
            this.ad = KeyFrameAnimationFactory.f.c(this.view.a(this.i).m(new AnimationKeyFrameProperty(1, 0)).m(new AnimationKeyFrameProperty(1, 1)));
        }
    };
    Object.defineProperty(Input.prototype, "i", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.db = function (a, b) {
        var c = a.playbackRate < 0;
        if (b != c) {
            a.play();
        }
        else {
            a.reverse();
        }
        if (this.au) {
            a.finish();
            a.commitStyles();
            return;
        }
        a.finished.f(function (d) { return a.commitStyles(); });
    };
    Input.$t = markType(Input, 'Input', InputGroupItem.$);
    Input.dt = BrushUtil.g(221, 0, 0, 0);
    Input.ds = BrushUtil.g(221, 0, 0, 0);
    Input.ab = null;
    Input.a9 = 0;
    return Input;
}(InputGroupItem));
export { Input };
//# sourceMappingURL=InputGroupView_combined.js.map
